<template>
	<div class="h-chat">
		<!-- <div class="h-header" :style="{'background-color':page.color}">
      <div class="wrap-header-middle" style="display: block">
        <div v-if="page.title_agentname_text" class="title">
          <p class="list-desc">{{$t('title_agentname_text')}}</p>
        </div>
      </div>
    </div> -->
		<div class="h-chat-iframe" v-if="open_iframe_link==1" style="width:100%;height: 100%;">
			<div class="h-header"  @click="open_iframe_link=0" style="background-color: rgba(243, 243, 245, 1); margin-bottom: 1px; box-shadow: 0px 0px 2px #cdcdcd; cursor: pointer;">
				<div class="h-header-top" data-v-477e75f8="" style="display: block; width: 100%;">
					<div class="widget-header-title text-center" style="color:rgba(13, 24, 45, 1);      font-weight: 500; font-size: 1.1em; text-align: left; padding-left: 10px; "> <i class="fa fa-angle-left" aria-hidden="true" style="padding-right: 10px;"></i>Tiếp tục chat</div>
				</div>
			</div>
			<iframe :src="iframe_link" style="width:100%;height: 92%;border:0"></iframe>
		</div>
		<div class="h-header" style="display: flex;background-color: transparent;padding:15px 1px" >
			<div class="h-header-top " style="    display: block;width: 100%;">
				<div class="">
					<div class="widget-header--top-wrapper">
						<div class="widget-header-title" style="color:rgba(13, 24, 45, 1);text-align: center;">
							Hỗ trợ trực tuyến
						</div>
						<div class="head-action" style="    text-align: center; display: flex; position: absolute; z-index: 99; right: 15px; top: 0px;">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"  v-on:click="minimize">
								<path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/>
							</svg>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" v-on:click="reload_iframe();reload_iframe_click=1" v-if="reload_iframe_click==0">
								<path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
							</svg>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" v-else >
								<path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="body">
			<div class="chatbox">
				<div class="chat-content-w scroll1">
					<div class="chat-content kkkk">
						<div v-for="(message, index_message) in messages" class="chat-message chat-message-main"
							:class="{self:message.user_id==st_token,text:(message.type=='text' && message.text !='')}">
							<div class="message-sender" :class="(message.attachments)?'message-sender-attachments':''">
								<img v-if="message.user_id!=st_token" class="chat-message-avatar" :alt="message.name"
									:title="message.name" :src="message.profile_pic">
								<p class="user-name" v-if="message.user_id!=st_token" :class="(message.type=='text' && message.text !='')?message.type:''">
									{{message.name}}
								</p>
							</div>
							<div class="chat-message-content-w" v-if="message.text !='' || message.url !=''">
								<template v-if="message.type=='text'">
									<div class="chat-message-content text-center" v-if="index_message == 0 && detectURL(message.text)=='Bắt đầu'">
										<div class="wrap-header-middle" style="display: block;">
					
											<div class="logo text-center" v-if="page.logo">
												<img :src="page.logo" :title="page.title_survey_heading">
											</div>
											<div class="widget-header-title text-center" style="font-weight: 500;font-size: 1.1em;margin-bottom: 10px;line-height: 17px;">
												{{$t('title_ready_text')}}
												<!-- title_survey_heading -->
												<span>{{$t('title_agentname_text')}}</span>
											</div>
											<p class="list-desc" v-html="$t('title_instruction_text')" style="opacity: 0.6;margin-bottom: 30px;" ></p>
										</div>
									</div>
									<div class="chat-message-content text-center" v-if="message.text=='Đánh giá' || message.text=='đánh giá' " style="    margin: 0 -7px;">
										<div class="wrap-header-middle" style="display: block;height: 100%;position: relative;text-align: center;">
											<!-- <a class="file_pdf" target='_blank' href="https://docs.google.com/forms/d/e/1FAIpQLSc5yfuhYXRHkwbHdMq965cuJci_TBQYvG8lyZ5y_D2xwBJmJQ/viewform" style="word-wrap: break-word; width: 100%; padding: 10px 3%;   text-align: left;border-radius: 10px;">
												https://docs.google.com/forms/d/e/1FAIpQLSc5yfuhYXRHkwbHdMq965cuJci_TBQYvG8lyZ5y_D2xwBJmJQ/viewform
												<div class="link-url-icon" style="margin-top: 5px;">
													<div class="link_url" ><i class="fa fa-link" aria-hidden="true"></i></div>
													<div class="title">
														<h5>Đánh giá chất lượng dịch vụ</h5>
														<div  >
															<span>PVcomBank trân trọng kính mời Quý khách tham gia ... </span>
														</div>
													</div>
												</div>
											</a> -->
											<div style="    position: absolute; top: 50%; left: calc(50% - 20px);font-size: 2em;text-align: cender;z-index: -1;color:rgb(26,115,232)"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></div>
											<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc5yfuhYXRHkwbHdMq965cuJci_TBQYvG8lyZ5y_D2xwBJmJQ/viewform" frameborder="0" style="width:100%;height:500px;z-index: 1;"></iframe>
										</div>
									</div>
									<div class="chat-message-content" v-else>
										<span class="message" v-if="message.user_id != st_token"
											v-html="detectURL(message.text)"
											:style="[message.user_id!=st_token ? {'background-color':page.color, 'color': '#fff'} : {}]"></span>
										<span class="message" v-else
											:style="[message.user_id!=st_token ? {'background-color':page.color, 'color': '#fff'} : {}]">{{message.text}}</span>
									</div>
								</template>
								<div class="chat-message-content" v-else-if="message.type=='image'">
									<a :href="message.url" target="_blank">
										<img style="width: 100%;" :src="message.url" :alt="message.text"
											:title="message.text">
									</a>
								</div>
								<div class="chat-message-content"
									v-else-if="message.type=='link' || message.type=='url'">
									<a :href="message.url" target="_blank">{{message.text ? message.text :
										message.url}}</a>
								</div>
							</div>
							<template v-if="message.attachments">
								<div class="chat-message-content-w" v-for="(file,index_file) in message.attachments">
									<div id="greenBar">
										<i class="fa fa-spinner fa-spin" aria-hidden="true"
											v-if="index_message==keyAddFile && keyAddFile!=0"></i>
										<i class="fa fa-check" aria-hidden="true" v-if="message.send_success==1 "
											style="font-size: 1em;opacity: .5;"></i>
									</div>
									<div class="chat-message-content">
										<a style="cursor: pointer;" target="_blank" v-if="file.type == 'image'"
											@click="openModalMedia(file.url,'image',getExtension(file.title))">
											<img style="width: 320px;margin-bottom: 5px;" :src="file.url"
												:alt="file.text" :title="file.text">
										</a>
										<div class="video_content" v-else-if="file.type == 'video'"
											style="width: 320px;padding:10px 5%;border-radius: 10px;"
											@click="openModalMedia(file.url,'video',getExtension(file.title))">
											<video style="width:100%" height="190" controls>
												<source :src="file.url" type="video/mp4">
												Your browser does not support the video tag.
											</video>
											<div class="video-icon">
												<img
													src="https://omnisales.worldfone.vn/portal/assets/images/video.svg">
												<div class="title">
													<h5>{{file.title}}</h5>
													<div>
														<span>{{Math.round(file.file_size/(1024*1024)*100)/100}}
															MB</span>
													</div>
												</div>
											</div>
										</div>
										<div class="template_list" v-else-if="file.type=='template'">
											<template v-if="file.payload.template_type == 'generic'">
												<div class="slider-container">
													<div class="slider" :data-index="index_message">
														<div class="slides" :id="'slides__' + index_message"
															:data-elements="file.payload.elements.length">
															<div v-for="(element, index) in file.payload.elements"
																:id="'slide__' + index_message + '_' + index"
																class="slide">
																<div class="slide__text">
																	<img :src="element.image_url" alt="">
																	<div class="detail">
																		<div class="title"
																			:style="{'color':page.color}">
																			{{element.title}}</div>
																		<div class="des">{{element.subtitle}}</div>

																		<template v-for="button in element.buttons">
																			<a v-if="button.type=='postback'"
																				v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																				class="button">{{button.title}}</a>
																			<a v-if="button.type=='web_url'"
																				:href="button.url" class="button"
																				target="_blank">{{button.title}}</a>

																		</template>

																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="wrap-arrow wrap-arrow-prev">
														<div class="inner-arrow">
															<a class="slide__prev"
																:id="'slide__prev_' + index_message"
																@click.prevent="changePrev(index_message)"
																:href="'#slide__' + index_message + '_' + (file.payload.elements.length - 1)"
																title="Prev"></a>
															<!-- <a class="slide__prev" :id="'slide__prev_' + index_message" :href="'#slide__' + index_message + '_' + (file.payload.elements.length - 1)" title="Prev"></a> -->
														</div>
													</div>
													<div class="wrap-arrow wrap-arrow-next">
														<div class="inner-arrow">
															<a class="slide__next"
																:id="'slide__next_' + index_message"
																@click.prevent="changeNext(index_message)"
																:href="'#slide__' + index_message + '_1'"
																title="Next"></a>
															<!-- <a class="slide__next" :id="'slide__next_' + index_message" :href="'#slide__' + index_message + '_1'" title="Next"></a> -->
														</div>
													</div>
												</div>
											</template>
											<template v-else-if="file.payload.template_type == 'media'">
												<div class="slider-container">
													<div class="slider" :data-index="index_message">
														<div class="slides" :id="'slides__' + index_message"
															:data-elements="file.payload.elements.length">
															<div v-for="(element, index) in file.payload.elements"
																:id="'slide__' + index_message + '_' + index"
																class="slide">
																<div class="slide__text">
																	<img :src="element.url" alt=""
																		v-if="element.media_type == 'image'">
																	<video width="320" height="240"
																		v-else-if="element.media_type == 'video'"
																		controls>
																		<source :src="element.url" type="video/mp4">
																		Your browser does not support the video tag.
																	</video>
																	<div class="detail">
																		<!-- <div class="title" :style="{'color':page.color}">{{element.title}}</div>
											<div class="des">{{element.subtitle}}</div> -->
																		<template v-for="button in element.buttons">
																			<a v-if="button.type=='postback'"
																				v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																				class="button">{{button.title}}</a>
																			<a v-if="button.type=='web_url'"
																				:href="button.url" class="button"
																				target="_blank">{{button.title}}</a>
																		</template>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
											<template v-else-if="file.payload.template_type == 'ticket'">
												<div class="slider-container" v-if="file.payload.template_data">
													<div class="slider slider--ticket" :data-index="index_message">
														<div class="slides" :id="'slides__' + key_message">
															<div class="slide">
																<div class="slide__text slide__text--ticket">
																	<h3 class="slide__text--ticket__title">
																		{{file.payload.template_data.title}}</h3>
																	<h6 class="slide__text--ticket__subtitle">
																		{{file.payload.template_data.subtitle}}</h6>
																	<template
																		v-if="file.payload.template_data.params">
																		<ul class="table-content-list pl-0">
																			<li
																				v-for="param in file.payload.template_data.params">
																				<div class="item">
																					<span>{{param.title}}</span>
																					<span
																						class="">{{param.value}}</span>
																				</div>
																			</li>
																		</ul>
																	</template>
																	<div class="detail detail--ticket text-center">
																		<template
																			v-for="button in file.payload.template_data.buttons">
																			<a v-if="button.type=='postback'"
																				v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																				class="button">{{button.title}}</a>
																			<a v-if="button.type=='web_url'"
																				:href="button.url" class="button"
																				target="_blank">{{button.title}}</a>
																		</template>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
											<div v-else>
												<ul class="list_ul">
													<li v-for="(element, index) in file.payload.elements">
														<div v-if="element.default_action && element.default_action.type=='web_url'"
															class="clearfix">
															<a :href="element.default_action.url"
																:title="element.title" target="_blank">
																<img :src="element.image_url" />
																<h3>{{element.title}}</h3>
																<p v-if="element.description">
																	{{element.description}}
																</p>
															</a>
														</div>
														<div v-else-if="element.default_action && element.default_action.type=='postback'"
															v-on:click="send_postback(message.id, element.default_action.payload, element.title, 'attachment_list')"
															class="clearfix">
															<img :src="element.image_url" />
															<h3>{{element.title}}</h3>
															<p v-if="element.description">{{element.description}}
															</p>
														</div>
														<div v-else class="clearfix">
															<img :src="element.image_url" />
															<h3>{{element.title}}</h3>
															<p v-if="element.description">{{element.description}}
															</p>
														</div>
													</li>
												</ul>
											</div>
										</div>
										
										<!-- <div>
										<a class="file_pdf" :href="file.url" target="_blank"
												v-if="file.type == 'file' && (getExtension(file.title)=='pdf' || getExtension(file.title)=='docx' || getExtension(file.title)=='xlsx'|| getExtension(file.title)=='xls'|| getExtension(file.title)=='doc'|| getExtension(file.title)=='rar'|| getExtension(file.title)=='zip'|| getExtension(file.title)=='ppt'|| getExtension(file.title)=='pptx')"
												style="width: 320px;padding:10px 5%;border-radius: 10px;">
												<div class="video-icon">
													<img :src="'/assets/images/'+getExtension(file.title)+'_icon.svg'">
													<div class="title">
														<h5>{{file.title}}</h5>
														<div  v-if="file.file_size != undefined">
															<span>{{Math.round(file.file_size/(1024*1024) *100)/100}}
																MB</span>
														</div>
													</div>
												</div>

											</a>
											<a :href="file.url" class="file_pdf" target="_blank"
												v-else-if="file.type == 'file' && (getExtension(file.title)!='pdf' && getExtension(file.title)!='docx' && getExtension(file.title)!='xlsx')"
												style="width: 320px;padding:10px 5%;border-radius: 10px;">
												<div class="video-icon">
													<div class="img"
														style="background-image: url('/assets/images/icon.svg');width: 42px;height:52px;background-size:100% 100%">
														<span>{{getExtension(file.title)}}</span>
													</div>
													<div class="title">
														<h5>{{file.title}}</h5>
														<div v-if="file.file_size != undefined">
															<span>{{Math.round(file.file_size/(1024*1024) *100)/100}}
																MB</span>
														</div>
													</div>
												</div>
											</a>
										</div> -->
									</div>
								</div>

							</template>

							<div v-if="message.quick_replies && message.quick_replies.status==1 && index_message == Object.keys(messages).length - 1"
								class="quick-replies">
								<template v-for="(reply, index) in message.quick_replies.data">

									<div class="reply" v-if="reply.content_type=='text'"
										:class="(reply.title =='Gặp tư vấn viên' || reply.title =='Agent support')?'active':''"
										v-on:click="send_postback(message.id, reply.payload, reply.title, 'reply')"
										:style="styleObject">
										<a>{{reply.title}}</a>
									</div>
									<div class="reply" v-if="reply.content_type=='postback'"
										:class="(reply.title =='Gặp tư vấn viên' || reply.title =='Agent support')?'active':''"
										v-on:click="send_postback(message.id, reply.payload, reply.title, 'reply')"
										:style="styleObject">
										<a>{{reply.title}}</a>
									</div>
									<div class="reply" v-if="reply.content_type=='web_url'"
										:class="(reply.title =='Gặp tư vấn viên' || reply.title =='Agent support')?'active':''"
										:style="styleObject">
										<a :href="reply.payload" target="_blank">{{reply.title}}</a>
									</div>
								</template>
							</div>

							<!-- <div v-if="message.quick_replies && message.quick_replies.status==1 && index_message == Object.keys(messages).length - 1" class="quick-replies" >
                      <div v-for="(reply, index) in message.quick_replies.data" class="reply" v-if="reply.content_type=='text'" :class = "(reply.title =='Gặp tư vấn viên')?'active':''" v-on:click="send_postback(message.id, reply.payload, reply.title, 'reply')" :style="{'border-color':page.color}">
                        <a >{{reply.title}}</a>
                      </div>
                      <div v-for="(reply, index) in message.quick_replies.data" class="reply" v-if="reply.content_type=='postback'" :class = "(reply.title =='Gặp tư vấn viên')?'active':''" v-on:click="send_postback(message.id, reply.payload, reply.title, 'reply')" :style="{'border-color':page.color}">
                        <a >{{reply.title}}</a>
                      </div>
                      <div v-for="(reply, index) in message.quick_replies.data" class="reply" v-if="reply.content_type=='web_url'" :class = "(reply.title =='Gặp tư vấn viên')?'active':''" :style="{'border-color':page.color}">
                        <a :href="reply.payload" target="_blank">{{reply.title}}</a>
                      </div>
                    </div> -->
					
							<div   :data-time="message.date_added" class="chat-message-date" v-if="(message.attachments != undefined && message.attachments[0] != undefined &&  message.attachments[0]['type']=='template') || (message.quick_replies && message.quick_replies.status==1 && index_message == Object.keys(messages).length - 1)"></div>
							<div   :data-time="message.date_added" class="chat-message-date" v-else><span v-if="(index_message == 0 && detectURL(message.text)=='Bắt đầu') || detectURL(message.text)=='đánh giá' || detectURL(message.text)=='Đánh giá'"></span><span v-else>{{message.date}}</span></div>
						</div>

						<div v-if="show_typing" class="chat-message show_typing">
							<div class="chat-message-content-w">
								<div class="chat-message-content">
									<span class="message" :style="{'background-color':page.color, 'color': '#fff'}" style="padding-bottom:0">
										<div class="loading-dots">
											<div class="loading-dots--dot"></div>
											<div class="loading-dots--dot"></div>
											<div class="loading-dots--dot"></div>
										</div>
									</span>
								</div>
							</div>
						</div>

						<app-rating-vietjet v-if="show_rating && page.parent_user =='C1184'"></app-rating-vietjet>
						<app-rating v-else-if="show_rating"></app-rating>
						<!-- <app-notification v-if="!isMobile() && setting_noti === '' "></app-notification> -->
					</div>
					<section v-if="show_suggest" aria-label="predictive suggestions"
						class="suggestions PredictiveSuggestions__list__container PredictiveSuggestions__list__container--desktop PredictiveSuggestions--collapsed"
						id="predictive-suggestions-container">
						<div class="PredictiveSuggestions__list__title PredictiveSuggestions__list__title--animate-in">
							<button type="button" class="PredictiveSuggestions__suggestions-heading"
								id="predictive-suggestions-heading" tabindex="0">
								Đề xuất
							</button>
						</div>
						<div class="PredictiveSuggestions__list__items PredictiveSuggestions__list__items--animate-in">
							<ul class="PredictiveSuggestions__list PredictiveSuggestions--animating-list-up PredictiveSuggestions__list--desktop"
								id="predictive-suggestions-list">
								<li v-for="suggest in suggest_data"
									class="PredictiveSuggestions__list__listItem--desktop" accesskey="f"><button
										v-on:click="clickMenu(suggest.value, suggest.title)"
										class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker"
										tabindex="0" type="button"
										style="color: rgb(240, 14, 14); animation-play-state: paused;"><span
											style="color: rgb(240, 14, 14);">{{suggest.title}}</span></button></li>

								<!-- <li class="PredictiveSuggestions__list__listItem--desktop" accesskey="g"><button class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker" tabindex="0" type="button" style="color: rgb(240, 14, 14); animation-play-state: paused;"><span style="color: rgb(240, 14, 14);">Bảo hiểm du lịch cho Covid-19 (Tune Protect)</span></button></li>
                        <li class="PredictiveSuggestions__list__listItem--desktop" accesskey="h"><button class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker" tabindex="0" type="button" style="color: rgb(240, 14, 14); animation-play-state: paused;"><span style="color: rgb(240, 14, 14);">Bay an toàn với VietJet Air</span></button></li> -->
							</ul>
						</div>
					</section>

				</div>
				<div id="modalStatus" class="modal-wrapper">
					<div class="modal">
						<a href="#close" title="Close" class="close" @click="closeModal()">X</a>
						<div class="modal-header">
							<h2>{{error.title}}</h2>
						</div>
						<div class="modal-content">
							<p>{{error.description}}</p>
						</div>
					</div>
				</div>
				<!-- modal image video -->
				<div id="modalMedia" class="modal-wrapper modal-wrapper-media" v-if="openPopupUMedia==1" style="opacity: 1; z-index: 999999999;">
					<div class="modal" :style="(filePopupType =='file')?'right: 0; top: 0px;bottom: 0px':''">
						<a style="cursor: pointer;" title="Close" class="close" @click="closeModalMedia()">X</a>

						<div class="modal-content" style="position: relative;">
							<i class="fa fa-spinner fa-spin" aria-hidden="true"
								style="z-index: -1;   position: absolute;margin: 0 auto;top: calc(50% - 15px);left: calc(50% - 15px);font-size: 2em;color:#1688c5"></i>
							<div style="z-index: 2;overflow-y: auto;">
								<div class="img" v-if="filePopupType =='image'"><img :src="filePopupUrl" alt="" style="max-width: 100%;"></div>
								<div class="media" v-else-if="filePopupType =='video'">
									<video style="width:100%" height="190" controls>
										<source :src="filePopupUrl" type="video/mp4">
										Your browser does not support the video tag.
									</video>
								</div>

								<div class="media" v-else-if="filePopupType =='file' && fileType=='pdf'">
									<iframe :src="filePopupUrl"
										style="z-index: 2;width:100%;height:600px;"></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--  -->
			</div>

			<div class="chat-controls">
				<div v-if="show_menu" class="mini-menu">
					<ul>
						<li v-for="menu_item in page.listmenu">
							<a v-if="menu_item.type=='postback'"
								v-on:click="clickMenu(menu_item.value, $t(menu_item.name)/*menu_item.name*/)">{{$t(menu_item.name)}}</a>
							<a v-else-if="menu_item.type=='website'" v-on:click="show_menu = false"
								:href="menu_item.value" target="_blank">{{$t(menu_item.name)}}</a>
							<a v-else-if="menu_item.type=='phone'" v-on:click="show_menu = false"
								:href="'tel:'+menu_item.value">{{$t(menu_item.name)}}</a>
						</li>
						<!-- <li>Gọi điện</li> -->
						<!-- <li>Hướng dẫn chung</li> -->
					</ul>
				</div>
				
				<div v-if="messageInputLength > 1024" style="font-size: .7em; color: #c00;text-align: center;">( Bạn
					không được nhập quá 1024 ký tự )</div>
				<div class="chat-input flex_container" style="display: flex; color: #808080;">
					<div class="flex_item icon-sendfile" style="vertical-align: bottom; display: flex;">
						<i v-if="page.listmenu" @click="show_menu = !show_menu" class="fas fa-bars"
							style="cursor: pointer;"></i>
						<!-- <i @click="upload_file" class="fas fa-paperclip" style="padding: 8px;cursor: pointer;"></i> -->
						<svg  @click="upload_file" style="cursor: pointer;margin: 7px;" width="24" height="24" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M9 5.25C7.48122 5.25 6.25 6.48122 6.25 8C6.25 9.51878 7.48122 10.75 9 10.75C10.5188 10.75 11.75 9.51878 11.75 8C11.75 6.48122 10.5188 5.25 9 5.25ZM7.75 8C7.75 7.30964 8.30964 6.75 9 6.75C9.69036 6.75 10.25 7.30964 10.25 8C10.25 8.69036 9.69036 9.25 9 9.25C8.30964 9.25 7.75 8.69036 7.75 8Z"/>
							<path fill-rule="evenodd" clip-rule="evenodd" d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22ZM15 20.5H9C6.64794 20.5 5.39172 20.0204 4.68566 19.3143C3.9796 18.6083 3.5 17.3521 3.5 15V9C3.5 6.64794 3.9796 5.39172 4.68566 4.68566C5.39172 3.9796 6.64794 3.5 9 3.5H15C17.3521 3.5 18.6083 3.9796 19.3143 4.68566C20.0204 5.39172 20.5 6.64794 20.5 9V11.6707C19.4476 11.0301 18.0093 11.117 17.0613 11.9311L12.9013 15.5011C12.4033 15.9288 11.5608 15.9296 11.0615 15.5035L10.7352 15.2166L10.7288 15.2111C9.75683 14.3761 8.24506 14.3041 7.18198 15.0173L3.7168 17.3439C3.84927 17.9418 4.03735 18.4106 4.26676 18.7813L8.01788 16.2628C8.53372 15.9168 9.30005 15.9638 9.74849 16.3465L10.0749 16.6334L10.0813 16.6389C11.1423 17.5503 12.8177 17.5501 13.8787 16.6389L18.0387 13.0689C18.5377 12.6404 19.3824 12.6404 19.8813 13.0689L20.5 13.6003V15C20.5 17.3521 20.0204 18.6083 19.3143 19.3143C18.6083 20.0204 17.3521 20.5 15 20.5Z" />
						</svg>
						<input id="FileSelectedValue" style="display: none; visibility: hidden;" ref="fileImage" type="file" accept="file_extension|audio/*|video/*|image/*|media_type" @change="onFileSelected" name="" value="" placeholder="">
					</div>
					<textarea class="flex_item_right " ref="input_chat" style="height: 38px; flex: 1;background-color:#E7E8EA;    border-radius: 25px; padding: 7px 10px;" v-model="message_input" @keydown.enter.exact.stop.prevent="enter_chat()" @input="mixin_autoResize_resize" v-on:keyup="handleKeyUp" :placeholder="$t('title_ready_enter_text')"></textarea>
					<div class="flex_item sendchat_box"  style="vertical-align: bottom; display: flex;">
						<div class="sendchat_button" @click.prevent="enter_chat()">
							<svg width="24" height="24" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
								<path d="M5.11698 21.507C3.99698 21.507 3.28698 21.127 2.83698 20.677C1.95698 19.797 1.33698 17.927 3.31698 13.957L4.18698 12.227C4.29698 11.997 4.29698 11.517 4.18698 11.287L3.31698 9.55698C1.32698 5.58698 1.95698 3.70698 2.83698 2.83698C3.70698 1.95698 5.58698 1.32698 9.54698 3.31698L18.107 7.59698C20.237 8.65698 21.407 10.137 21.407 11.757C21.407 13.377 20.237 14.857 18.117 15.917L9.55698 20.197C7.61698 21.167 6.17698 21.507 5.11698 21.507ZM5.11698 3.50698C4.57698 3.50698 4.15698 3.63698 3.89698 3.89698C3.16698 4.61698 3.45698 6.48698 4.65698 8.87698L5.52698 10.617C5.84698 11.267 5.84698 12.247 5.52698 12.897L4.65698 14.627C3.45698 17.027 3.16698 18.887 3.89698 19.607C4.61698 20.337 6.48698 20.047 8.88698 18.847L17.447 14.567C19.017 13.787 19.907 12.757 19.907 11.747C19.907 10.737 19.007 9.70698 17.437 8.92698L8.87698 4.65698C7.35698 3.89698 6.04698 3.50698 5.11698 3.50698Z" />
								<path d="M10.8404 12.75H5.44043C5.03043 12.75 4.69043 12.41 4.69043 12C4.69043 11.59 5.03043 11.25 5.44043 11.25H10.8404C11.2504 11.25 11.5904 11.59 11.5904 12C11.5904 12.41 11.2504 12.75 10.8404 12.75Z" />
							</svg>
						</div>
					</div>
					
				</div>
				<!-- <div class="chat-action">
                <a class="btn-upload" @click="upload_file"><i class="fas fa-paperclip"></i></a>
                <div>
                  <input style="display: none; visibility: hidden;" ref="fileImage" type="file" accept="file_extension|audio/*|video/*|image/*|media_type" @change="onFileSelected" name="" value="" placeholder="">
                </div>
              </div> -->

				<!-- </div> -->
			</div>
		</div><!--body-->

		<div class="footer-note" v-if="page.privacy_link">
			<a class="product" target="_blank" :href="page.privacy_link">Quyền riêng tư</a>
		</div>
		<div class="footer-note" v-else>
			<label class="lang-option" v-if="page.parent_user =='user_1414589598653489' || page.parent_user =='C1184'">
				<i :style="{'color': page.color}" class="fas fa-globe"></i> {{$t('language')}}
				<select v-model="lang" @change="setLang($event)">
					<option value="vi">Tiếng Việt</option>
					<option value="en">English</option>
				</select>
			</label>
			<div v-if="page.hide_power_by!='on' && page.hide_power_by!=1">
				<span>⚡ by </span><a class="product" target="_blank"
					href="https://worldfone.vn/dich-vu/tong-dai-contact-center-worldfone4x"> Worldfone4Omni</a>
			</div>

		</div>

	</div>

</template>

<script>
	/*import $ from "jquery";
	// import $ from './assets/js/jquery.min.js'
	// Binding of init has to be before intialization!
$('.slick-slider').on('init', (event, slick, currentSlide) => {
let slideIndex = slick.currentSlide;
let slidesLength = slick.slideCount;
});
console.log($('body').html());
// Initialise.
$('.slick-slider').slick({
slidesToShow: 1,
dots: true,
//centerMode: true,
responsive: [
{
breakpoint: 768,
settings: {
  slidesToShow: 1 } }] });





let slideIndex = $('.slick-slide:not(.slick-cloned)').length;
$('.add-slide').on('click', () => {
slideIndex++;
$('.slick-slider').slick('slickAdd', '<li><h3>' + slideIndex + '</h3></li>');
$('.slick-slider').slick('slickGoTo', 'slickCurrentSlide' + 1);
});

$('.remove-slide').on('click', () => {
$('.slick-slider').slick('slickRemove', slideIndex - 1);
if (slideIndex !== 0) {
slideIndex--;
}
});*/
	//# sourceURL=pen.js

	// import io from 'socket.io-client';
	import Rating from '../components/rating.vue';
	import rating_vietjet from '../components/rating_vietjet.vue';
	import notification1 from '../components/notification.vue';
	import sound from '../assets/media/notif.mp3';
	import axios from 'axios';
	export default {
		components: {
			'app-rating': Rating,
			'app-rating-vietjet': rating_vietjet,
			'app-notification': notification1
		},
		props: ['page', /*'show_launcher', '', 'first_component'*/],
		data() {
			return {
				setting_sound: window.livechat.setting_sound,
				setting_noti: window.livechat.setting_noti,
				// setting_language: window.livechat.setting_language,
				new_message_number: 0,
				message_input: '',
				messages: [],
				agent_id: '',
				agent: {
					name: '',
					avatar: '',
				},
				user_has_created: false,
				selectedFile: null,
				current_time_m: ENV.current_time,
				current_time_n: ENV.current_time,
				timer: '',
				timeoutVal: 500, // time it takes to wait for user to stop typing in ms,
				timer_show_typing: '',
				//console.log(livechat.getLanguages());
				lang1: '',
				show_suggest: 0,
				suggest_data: [],
				show_typing: 0,
				show_menu: 0,
				/*menus:[
				{type: 'postback', name: 'Danh mục chính', value: '#daddasadasdas'},
				{type: 'website', name: 'Hướng dẫn chung', value: 'https://omnicxm.worldfone.cloud/omni/botai/view/detail/61c932994a67137a262ab3f2'},
				{type: 'phone', name: 'Gọi hỗ trợ', value: '0366446318'}
				]*/
				// show_notification: 'true',
				slideIndexes: {},
				customerFeedbackConfig: null,
				error: {
					title: '',
					description: '',
				},
				phoneNumber: '',
				keyAddFile: 0,
				msg_idAddFile: '',
				keyAddFileSuccess: '',
				max_stars: 5,
				reloadinterval: 0,
				datawindowInfo: [],
				// typeFileAdd:'',
				// nameFileAdd:'',
				session_url: '',
				session_starttime: '',
				interaction_click: 0,
				interaction_view: 0,
				exact_interaction_click: 0,
				form_interaction_submit: 0,
				interaction_scroll: 0,
				microphone_open:0,
				microphone_show:0,
				audioUrl:'',
				stream:[],
				show_microphone:false,
				mediaRecorder:'',
				loadding:0,
				no_send_file:0,
				recording_tab:0,
				recording_delete:0,
				test123:'',
				blobData:'',
				reload_iframe_click:0,
				has_firts_message: 0,
				
			}
		},

		computed: {
			styleObject: function () {
				return {
					'--borderColor': this.page.color,
					'--color': this.page.color,
					'--colorHover': '#fff',
				}
			},
			st_token() {
				return this.$store.state.st_token;
			},
			lang() {
				return this.$store.state.lang;
			},
			show_rating() {
				return this.$store.state.show_rating;
			},
			page() {
				return this.$store.state.page;
			},
			hasFocus() {
				return this.$store.state.hasFocus;
			},
			show_launcher() {
				
				var $self = this;
				
				// if (this.$store.state.show_launcher == 1 && this.page.parent_user == 'P0008_prod' && this.messages <= 0 && this.has_firts_message == 0) {
				if (this.$store.state.show_launcher == 1 && this.messages <= 0 && this.has_firts_message == 0) {
					this.has_firts_message = 1;
					this.message_input = 'Bắt đầu';
					this.enter_chat();

				}
				return this.$store.state.show_launcher;
			},
			first_component() {
				return this.$store.state.first_component;
			},
			messageInputLength() {
				return this.message_input.length;
			},
		},
		methods: {
			addVoiceText: function (value) {
                var _vm = this;
				this.message_input = value;
                setTimeout(function () {
					_vm.mixin_autoResize_resize();
				}, 50);
				
            },
			openMicrophone() {
				
				let now = new Date();
				now=now.toLocaleTimeString();
				let _vmChat = this;
				_vmChat.message_input = '';
				_vmChat.audioUrl='';
				_vmChat.microphone_open=1;
				document.getElementById("audioTest").src = '';
                document.getElementById("myAudio").load();
				navigator.mediaDevices.getUserMedia({video: false, audio: true})
				.then(stream => {
					_vmChat.message_input = ' ';
					_vmChat.stream =stream;
					const mediaRecorder = new MediaRecorder(stream);
					_vmChat.mediaRecorder =mediaRecorder;
					const chunks = [];
					mediaRecorder.ondataavailable = event => {
						if (event.data.size > 0) {
							chunks.push(event.data);
						}
					};
					mediaRecorder.onstop = () => {
						let mimeType = mediaRecorder.mimeType;
						
						_vmChat.microphone_show=0;
						const blob = new Blob(chunks, { type: 'audio/wave' });
						_vmChat.blobData=blob;
						const audioUrl = URL.createObjectURL(blob);
						if(_vmChat.recording_tab==1){
							if(_vmChat.recording_delete!=1){
								_vmChat.audioUrl=audioUrl;
								document.getElementById("audioTest").src = audioUrl;
								document.getElementById("myAudio").load(true);
								_vmChat.mediaRecorder='';
								_vmChat.loadding = 0;
								_vmChat.message_input = '';
							}else{
								_vmChat.mediaRecorder='';
								_vmChat.loadding = 0;
								_vmChat.message_input = '';
								_vmChat.recording_delete=0;
								_vmChat.blobData='';
							}
						}else{
							_vmChat.microphone_open=0;
							_vmChat.loadding = 1;
							// Làm gì đó với audioUrl (ví dụ: hiển thị trong một thẻ audio)
							if(_vmChat.no_send_file==0){
								const formData = new FormData();
								formData.append('audio', blob, 'audio.wav');
								axios.post('/app/v1/public/v3/get_voice_text', formData,{
									params: {
										text: '',
										sender_id: _vmChat.st_token,
										name: window.user.name,
										survey_data: {
											name: window.user.name,
											phone: window.user.phone,
											email: window.user.email,
											address: window.user.address
										},
										properties: window.user.properties
									},
									headers: {
									"Content-Type": "multipart/form-data",
									},
								})
								.then(function (response) {
									_vmChat.loadding = 0;
									_vmChat.message_input = '';
									if (response.data.status == 1) {
										_vmChat.addVoiceText(response.data.data)
										let end = new Date();
										end=end.toLocaleTimeString();
										// console.log(now + '--' + end)
										_vmChat.mediaRecorder='';
									} else{
										// _vmChat.test123=JSON.stringify(response.data);
									}
								}).catch(function(jqXHR, textStatus, errorThrown){
									console.log(textStatus + ": " + jqXHR.status + " " + errorThrown);
									console.log(error);
									// _vmChat.test123=JSON.stringify(textStatus);
									_vmChat.mediaRecorder='';
									_vmChat.loadding = 0;
									_vmChat.message_input = '';
								});
								_vmChat.blobData='';
							}else{
								_vmChat.loadding = 0;
								_vmChat.message_input = '';
								_vmChat.mediaRecorder='';
								_vmChat.microphone_open=0;
								_vmChat.no_send_file=0
								_vmChat.blobData='';
							}
						}
						stream.getTracks().forEach(function(track) { 
							track.stop(); 
						}) 
					};
					// Bắt đầu ghi âm
					mediaRecorder.start();
					// Dừng ghi âm sau một khoảng thời gian nào đó
					setTimeout(() => {
						if(mediaRecorder.state == 'recording'){
							mediaRecorder.stop();
						}
					
					}, 7000); // Dừng sau 7 giây, bạn có thể điều chỉnh thời gian theo ý muốn
					return false;
				})
				.catch(error => {
					_vmChat.microphone_open=0;
					alert(error)
				});
			},
			closeMicrophone(event) {
				let _vmChat = this;
				
				// if (_vmChat.stream != undefined && _vmChat.stream !='') {
				// 	_vmChat.stream.getTracks().forEach(function(track) { 
				// 		track.stop(); 
				// 	})
				// }
				if (_vmChat.mediaRecorder != undefined && _vmChat.mediaRecorder !='') {
					if(_vmChat.mediaRecorder.state == 'recording'){
					_vmChat.mediaRecorder.stop()
					}
				};
				
			},
			poll: function () {
				var self1 = this;
				var ajax = new XMLHttpRequest();
				ajax.onreadystatechange = function () {
					if (this.readyState === 4 && this.status === 200) {
						if (this.status === 200) {
							try {
								var json = JSON.parse(this.responseText);
								if (json.status == 1) {
									self1.current_time_m = json['ts'];

									self1.add_messages(json['data']);
									self1.poll();

								} else {
									// console.log(json.error);
									setTimeout(() => {
										self1.poll();
									}, 3000);
								}
							} catch {
								self1.current_time_m = self1.current_time_m + 3;
								self1.poll();
								return;
							}
						} else {
							setTimeout(() => {
								self1.poll();
							}, 3000);
						}

					} else if (this.status > 299 && this.readyState == 4) {
						setTimeout(() => {
							self1.poll();
						}, 3000);
						console.log('Server Error: ' + ajax.statusText);
					} else {
					}
				}
				ajax.onerror = function () {
					console.log('xmlHTTP Error', ajax.responseText);
					setTimeout(() => {
						self1.poll();
					}, 3000);
				}

				ajax.open('GET', '/app/v1/public/pull/message/' + self1.st_token + '/' + self1.current_time_m, true);
				ajax.send();

			},
			polln: function () {
				var self1 = this;
				var ajax = new XMLHttpRequest();
				ajax.onreadystatechange = function () {
					if (this.readyState === 4 && this.status === 200) {
						if (this.status === 200) {
							try {
								var json = JSON.parse(this.responseText);
								if (json.status == 1) {
									self1.current_time_n = json['ts'];
									json['data'].forEach(function (message, index) {
										if (message.trigger == 'rating') {
											self1.$store.commit('show_rating', true);
										} else if (message.trigger == 'suggest') {
											self1.show_suggest = true;
											self1.suggest_data = message.suggest;
											setTimeout(function () {
												self1.scrollToEnd();
											}, 250);
											// self1.$store.commit('show_suggest', true);
										} else if (message.trigger == 'change_language') {
											self1.setLangNotificationEvent(message.language);
										}
									});

									self1.polln();

								} else {
									console.log(json.error);
									setTimeout(() => {
										self1.polln();
									}, 3000);
								}
							} catch {
								self1.current_time_n = self1.current_time_n + 3;
								self1.polln();
								return;
							}
						} else {
							setTimeout(() => {
								self1.polln();
							}, 3000);
						}

					} else if (this.status > 299 && this.readyState == 4) {
						setTimeout(() => {
							self1.poll();
						}, 3000);
						console.log('Server Error: ' + ajax.statusText);
					} else {
					}
				}
				ajax.onerror = function () {
					console.log('xmlHTTP Error', ajax.responseText)
					setTimeout(() => {
						self1.polln();
					}, 3000);
				}
				ajax.open('GET', '/app/v1/public/pull/notifications/' + self1.st_token + '/' + self1.current_time_n, true);
				ajax.send();
			},
			mixin_autoResize_resize() {
				let val=this.$refs.input_chat.value ;
				if (val  == ''  || ((Object.keys(val.split(/\r|\r\n|\n/)).length==1) && this.$refs.input_chat.scrollHeight <40)) {
					this.$refs.input_chat.style.height = '38px';
				} else {
					this.$refs.input_chat.style.height = "auto";
					this.$refs.input_chat.style.height = `${this.$refs.input_chat.scrollHeight}px`;
				}

			},
			add_messages: function (data) {
				var $self = this;
				$self.$store.commit('show_rating', false);
				data.forEach(function (message1, index) {
					var msg_id = message1.msg_id;
					// console.log(msg_id);
					if (typeof msg_id !== 'undefined') {
						var index = $self.messages.findIndex(message => message.msg_id === msg_id);
						// console.log(index);
						if (parseInt(index) >= 0) {
							//update đã nhận
							if ($self.msg_idAddFile == msg_id) {
								$self.keyAddFile = 0;
								var msgTemp = message1;
								// $self.$set(msgTemp, 'send_success', 1);
								message1.send_success = 1;
							}
							$self.messages.splice(index, 1, message1);
						} else {
							$self.messages.push(message1);
						}
						// console.log($self.messages)
					} else {
						$self.messages.push(message1);
					}

					// $self.messages.push(message1);
					$self.new_message_number++;
					$self.$emit('new_message_number', $self.new_message_number);

					// if (message1.user_id!= $self.st_token && $self.setting_sound==true) {        
					//   // $self.playSound(sound);
					// }
					if (message1.user_id != $self.st_token) {
						$self.set_show_typing(0);
					}
					if (message1.user_id != $self.st_token && $self.setting_noti == true) {
						$self.showNotification(message1.name, message1.text, message1.profile_pic);
					}
				});
				setTimeout(function () {
					$self.scrollToEnd();
				}, 250);


			},
			getPrivacyContent: function (content) {
				var regex = /\[(.*?)\]\((.*?)\)/g;
				var allDetectedText = [...content.matchAll(regex)];
				var replaceText = '';
				$.each(allDetectedText, function (key, detectedText) {
					if (detectedText != undefined && detectedText.length == 3) {
						var url = detectedText[2];
						var title = detectedText[1]
						if (!replaceText.length) replaceText = '<a href=' + url + ' target="_blank" style="text-transform: capitalize;">' + title + '</a>';
						// newContent = newContent.replace(detectedText[0], replaceText);
					}
				})
				return replaceText;
			},
			getExtension(filename) {
				if (filename != undefined && filename.length > 0) {
					var parts = filename.split('.');
					return parts[parts.length - 1];
				} else {
					return '';
				}
			},

			async onFileSelected(event) {
				var $self = this;
				$self.selectedFile = event.target.files[0];
				// console.log($self.selectedFile.name)
				let typeFile = $self.getExtension($self.selectedFile.name);
				// let exclusionType=['exe','bat','msi','bin'] ;
				let exclusionType = ['xlsx', 'xls', 'pdf', 'txt', 'doc', 'docx', 'ppt', 'pptx', 'zip', 'rar'];
				let videoType = ['mp4', 'mpeg', 'x-ms-wmv', 'quicktime','wav'];
				let imageType = ['jpeg', 'png', 'jpeg', 'jpg'];
				let type = '';
				let extension = typeFile;
				var d = new Date();
				if (videoType.includes(typeFile)) {
					typeFile = 'video';
					type = 'video';
				}
				if (imageType.includes(typeFile)) {
					typeFile = 'image';
					type = 'image';
				}

				if (!exclusionType.includes(typeFile) && type.length == 0) {
					$self.error.title = 'Lỗi';
					$self.error.description = 'File của bạn gửi không hợp lệ.';
					$('#modalStatus').css('opacity', 1);
					$('#modalStatus').css('zIndex', 999999999)
					return false;
				} else {
					type = 'file';
				}
				if ($self.selectedFile.size <= 1024 * 1024 * 25) {
					$self.msg_idAddFile = '';
					let files = $('#FileSelectedValue')[0].files;
					let newObjectUrl = URL.createObjectURL(files[0]);
					// console.log(newObjectUrl)
					const formdata = new FormData();

					formdata.append('file', $self.selectedFile, $self.selectedFile.name);
					$self.keyAddFile = $self.messages.length;
					var msg_id = $self.uid();
					$self.msg_idAddFile = msg_id;
					let attachments = [];
					let attachments_data = {
						'extension': extension,
						'file_size': $self.selectedFile.size,
						'mimetype': $self.selectedFile.type,
						'raw_file_name': $self.selectedFile.name,
						'type': type,
						'title': $self.selectedFile.name,
						'url': newObjectUrl
					};
					attachments.push(attachments_data);
					$self.messages.push({
						id: "",
						attachments: attachments,
						msg_id: msg_id,
						type: "text",
						is_rated: 0,
						profile_pic: "",
						rating_recommend: "",
						rating_star: 0,
						text: '',
						url: '',
						name: window.user.name,
						user_id: $self.st_token,
						date_added: Math.floor(Date.now() / 1000),
						date: d.getHours() + ":" + d.getMinutes()
					});
					$self.scrollToEnd();
					// console.log($self.messages)
					// .file_pdf_progress.progress
					// formdata.append('a', {page_id: livechat.getId()})
					// formdata.append('data', {
					//   page_id: livechat.getId(),
					//   text: $self.selectedFile.name,
					//   sender_id: $self.st_token,
					//   name: window.user.name,
					//   survey_data: {
					//     name:window.user.name,
					//     phone:window.user.phone,
					//     email:window.user.email,
					//     address:window.user.address
					//   },
					//   properties:window.user.properties
					// }/*this.selectedFile,this.selectedFile.name*/);
					await axios.post('/app/v1/public/upload/image', formdata, {
						params: {
							page_id: livechat.getId(),
							msg_id: msg_id,
							text: $self.selectedFile.name,
							sender_id: $self.st_token,
							name: window.user.name,
							survey_data: {
								name: window.user.name,
								phone: window.user.phone,
								email: window.user.email,
								address: window.user.address
							},
							properties: window.user.properties
						},
						headers: {
							"Content-Type": "multipart/form-data",
						},
					})
						.then(function (response) {
							/*socket.emit('SEND_IMG' ,{
								page_id: livechat.getId(),
								text: $self.selectedFile.name,
								url: response.data.content,
								sender_id: $self.st_token,
								name: window.user.name,
								survey_data: {
								name:window.user.name,
								phone:window.user.phone,
								email:window.user.email,
								address:window.user.address
								}, 
								properties:window.user.properties
							});*/
							$("#FileSelectedValue").val('');
							if (response.data.status == 0) {
								$self.messages.splice($self.keyAddFile, 1);
								$self.keyAddFile = 0;
								$self.msg_idAddFile = '';
								$self.error.title = 'Error!';
								$self.error.description = response.data.error;
								$('#modalStatus').css('opacity', 1);
								$('#modalStatus').css('zIndex', 999999999)
							}
							else {
								$self.keyAddFileSuccess = $self.keyAddFile;
								$self.keyAddFile = 0;
							}
						})
						.catch(function (error) {
							console.log(error.data);
							// console.log(error);
						})
				}
				else {
					$self.error.title = 'Lỗi';
					$self.error.description = 'Dung lượng file không được quá 25MB';
					$('#modalStatus').css('opacity', 1);
					$('#modalStatus').css('zIndex', 999999999)
				}
			},
			upload_file: function ($event) {
				var $self = this;
				var elem = this.$refs.fileImage
				elem.click()
				const formdata = new FormData();
				formdata.append('file', this.selectedFile);
			},
			async upload_file_audio($event) {
				
				var self = this;
				self.loadding = 1;
				self.message_input =' ';
				var msg_id = self.uid();
				var d = new Date();
				const formData = new FormData();
				formData.append('audio', self.blobData, 'audio.wav');
				axios.post('/app/v1/public/v3/updateAudio', formData,{
					params: {
						page_id: livechat.getId(),
						msg_id: msg_id,
						sender_id: self.st_token,
						name: window.user.name,
						survey_data: {
							name: window.user.name,
							phone: window.user.phone,
							email: window.user.email,
							address: window.user.address
						},
						properties: window.user.properties
					},
					headers: {
					"Content-Type": "multipart/form-data",
					},
				})
				.then(function (response) {
					if (response.data.status == 1) {
						
						let data=response.data.data;
						// self.message_input = response.data.mini;
						let attachments = [];
						let attachments_data = {
							'extension': data.extension,
							'file_size': data.file_size,
							'mimetype': data.mimetype,
							'raw_file_name': data.save_file_name,
							'type': 'audio',
							'title':  data.save_file_name,
							'url': data.url
						};
						attachments.push(attachments_data);
						self.messages.push({
							id: "",
							attachments: attachments,
							msg_id: msg_id,
							type: "text",
							is_rated: 0,
							profile_pic: "",
							rating_recommend: "",
							rating_star: 0,
							text: '',
							url: '',
							name: window.user.name,
							user_id: self.st_token,
							date_added: Math.floor(Date.now() / 1000),
							date: d.getHours() + ":" + d.getMinutes()
						});
						
						self.scrollToEnd();
					} else{
						console.log(response.data);
						// _vmChat.test123=JSON.stringify(response.data);
					}
					// self.message_input ='';
					self.loadding = 0;
				}).catch(function(jqXHR, textStatus, errorThrown){
					console.log(textStatus + ": " + jqXHR.status + " " + errorThrown);
				});
			},
			generate_uuid4: function (e) {
				var dt = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (dt + Math.random() * 16) % 16 | 0;
					dt = Math.floor(dt / 16);
					return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
				});
				return uuid;
			},
			enter_chat(e) {
				var $self = this;
				if (!$self.st_token) {
					$self.$store.commit('set_token', $self.generate_uuid4());
					livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token', $self.st_token);
					$self.poll();
					$self.polln();
				}
				if ($self.messageInputLength < 1024) {
					this.show_suggest = false;
					this.$refs.input_chat.style.height = '38px';
					var text = this.message_input.trim();
					var msg_id = $self.uid();
					var d = new Date();
					window.clearTimeout(this.timer);
					//gởi tin nhắn
					var text_trim = text.trim();
					if (text_trim == '' || text_trim === null) {
						$self.message_input = '';
						return false;
					} else {
						$self.messages.push({
							id: "",
							msg_id: msg_id,
							trigger: "message",
							source: "livechat",
							type: "text",
							text: $self.escapeHtml(text),
							user_id: $self.st_token,
							date_added: Math.floor(Date.now() / 1000),
							date: d.getHours() + ":" + d.getMinutes()
						});

						$self.sendMessage(text, msg_id);

						$self.message_input = '';
						// console.log($self.message_input);


						$self.scrollToEnd();
						// e.preventDefault();
						return false;
					}
				}
			},
			sendMessage: function (text, msg_id = '') {
				var $self = this;
				axios.post('/app/v1/public/SEND_MESSAGE', {
					page_id: livechat.getId(),
					msg_id: msg_id,
					text: text,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					properties: window.user.properties
				}).then((response) => {
					if (response.data.status == 1) {
					}
					if (response.data.show_typing) {
						if ($self.page.parent_user == 'C1184') {
							window.setTimeout(() => {
								$self.set_show_typing(1, 3);
							}, 800);
						}
						else {
							window.setTimeout(() => {
								$self.set_show_typing(1, 10);
							}, 300);
						}
					}
				}).catch(error => {
					console.log(error);
				});
			},
			handleKeyUp(e) {
				if (e.keyCode === 13) {
				} else {
					window.clearTimeout(this.timer); // prevent errant multiple timeouts from being generated
					this.timer = window.setTimeout(() => {
						var $self = this;
						$self.getSuggestions();
					}, this.timeoutVal);
				}
			},
			set_show_typing(show_typing, seconds = 3) {
				var $self = this;
				$self.show_typing = show_typing;
				window.clearTimeout(this.timer_show_typing); // prevent errant multiple timeouts from being generated

				if (show_typing) {
					var lastMes = null;
					if ($self.messages && $self.messages.length > 0) {
						lastMes = $self.messages[$self.messages.length - 1];
					}
					if (lastMes && lastMes.user_id != $self.st_token) { //neu ko phải do page nhắn mà do user nào dc assign
						$self.set_show_typing(0);
					}
					else{
						this.timer_show_typing = window.setTimeout(() => {
							// var $self = this;
							$self.set_show_typing(0);
						}, seconds * 1000);
					}
				}
			},
			getLocation(message_id) {
				var $self = this;
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {
						// Retrieve the latitude and longitude
						var latitude = position.coords.latitude;
						var longitude = position.coords.longitude;

						// Do something with the coordinates, e.g., display them on the webpage
						return { latitude: latitude, longitude: longitude }
					}, function (error) {
						// Handle any errors that occur during geolocation
						switch (error.code) {
							case error.PERMISSION_DENIED:
								console.error("User denied the request for geolocation.");
								break;
							case error.POSITION_UNAVAILABLE:
								console.error("Location information is unavailable.");
								break;
							case error.TIMEOUT:
								console.error("The request to get user location timed out.");
								break;
							case error.UNKNOWN_ERROR:
								console.error("An unknown error occurred.");
								break;
						}
					});

				} else {
					return "Geolocation is not supported by this browser.";
				}
			},
			// showPosition(position) {

			// 	return {latitude: position.coords.latitude,longitude:position.coords.longitude}
			// },
			send_postback(message_id, payload, title, type) {
				var $self = this;
				var msg_id = $self.uid();
				var d = new Date();

				$self.messages.push({
					id: "",
					msg_id: msg_id,
					trigger: "message",
					source: "livechat",
					type: "text",
					text: title,
					user_id: $self.st_token,
					date_added: Math.floor(Date.now() / 1000),
					date: d.getHours() + ":" + d.getMinutes()
				});
				let location = [];
				if (type == 'location') {
					if (navigator.geolocation) {
						navigator.geolocation.getCurrentPosition(function (position) {
							// Retrieve the latitude and longitude
							var latitude = position.coords.latitude;
							var longitude = position.coords.longitude;

							// Do something with the coordinates, e.g., display them on the webpage
							location = { latitude: latitude, longitude: longitude };
							axios.post('/app/v1/public/SEND_POSTBACK', {
								page_id: livechat.getId(),
								msg_id: msg_id,
								sender_id: $self.st_token,
								name: window.user.name,
								windowInfo: livechat.windowInfo,
								survey_data: {
									name: window.user.name,
									phone: window.user.phone,
									email: window.user.email,
									address: window.user.address
								},
								postback: {
									message_id: message_id,
									// index: index,
									payload: payload,
									title: title,
									type: type,
									location: location
								},

								properties: window.user.properties
							}).then((response) => {
								if (response.data.show_typing) {
									window.setTimeout(() => {
										$self.set_show_typing(1, 10);
									}, 300);

								}
							}).catch(error => {
								console.log(error);
							});
						}, function (error) {
							// Handle any errors that occur during geolocation
							switch (error.code) {
								case error.PERMISSION_DENIED:
									location = { 'error': 1, 'message': 'User denied the request for geolocation.' }
									break;
								case error.POSITION_UNAVAILABLE:
									location = { 'error': 1, 'message': 'Location information is unavailable.' }
									break;
								case error.TIMEOUT:
									location = { 'error': 1, 'message': 'The request to get user location timed out.' }
									break;
								case error.UNKNOWN_ERROR:
									location = { 'error': 1, 'message': 'An unknown error occurred.' }
									break;
							}
							axios.post('/app/v1/public/SEND_POSTBACK', {
								page_id: livechat.getId(),
								msg_id: msg_id,
								sender_id: $self.st_token,
								name: window.user.name,
								windowInfo: livechat.windowInfo,
								survey_data: {
									name: window.user.name,
									phone: window.user.phone,
									email: window.user.email,
									address: window.user.address
								},
								postback: {
									message_id: message_id,
									// index: index,
									payload: payload,
									title: title,
									type: type,
									location: location
								},

								properties: window.user.properties
							}).then((response) => {
								if (response.data.show_typing) {
									window.setTimeout(() => {
										$self.set_show_typing(1, 10);
									}, 300);

								}
							}).catch(error => {
								console.log(error);
							});
						});

					} else {
						location = { 'error': 1, 'message': 'Geolocation is not supported by this browser.' }
						axios.post('/app/v1/public/SEND_POSTBACK', {
							page_id: livechat.getId(),
							msg_id: msg_id,
							sender_id: $self.st_token,
							name: window.user.name,
							windowInfo: livechat.windowInfo,
							survey_data: {
								name: window.user.name,
								phone: window.user.phone,
								email: window.user.email,
								address: window.user.address
							},
							postback: {
								message_id: message_id,
								// index: index,
								payload: payload,
								title: title,
								type: type,
								location: location
							},

							properties: window.user.properties
						}).then((response) => {
							if (response.data.show_typing) {
								window.setTimeout(() => {
									$self.set_show_typing(1, 10);
								}, 300);

							}
						}).catch(error => {
							console.log(error);
						});
					}



				} else {
					axios.post('/app/v1/public/SEND_POSTBACK', {
						page_id: livechat.getId(),
						msg_id: msg_id,
						sender_id: $self.st_token,
						name: window.user.name,
						windowInfo: livechat.windowInfo,
						survey_data: {
							name: window.user.name,
							phone: window.user.phone,
							email: window.user.email,
							address: window.user.address
						},
						postback: {
							message_id: message_id,
							// index: index,
							payload: payload,
							title: title,
							type: type,
						},

						properties: window.user.properties
					}).then((response) => {
						if (response.data.show_typing) {
							window.setTimeout(() => {
								$self.set_show_typing(1, 10);
							}, 300);
						}
					}).catch(error => {
						console.log(error);
					});
				}

			},
			clickMenu(payload, title) {
				var $self = this;
				$self.show_menu = false;
				$self.show_suggest = false;
				var msgID = $self.uid();
				var d = new Date();
				this.messages.push({
					id: "",
					msg_id: msgID,
					trigger: "message",
					source: "livechat",
					type: "text",
					text: title,
					user_id: this.st_token,
					date_added: Math.floor(Date.now() / 1000),
					date: d.getHours() + ":" + d.getMinutes()
				});

				axios.post('/app/v1/public/SEND_POSTBACK', {
					page_id: livechat.getId(),
					msg_id: msgID,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					postback: {
						payload: payload,
						title: title,
					},
					// properties:window.user.properties
				}).then((response) => {
					if (response.data.status == 1) {

					}
				}).catch(error => {
					console.log(error);
				});
			},
			minimize: function () {
				$('.h-btn').removeClass('zoomOut');
				$('.hotline-launcher').hide();
				this.new_message_number = 0;
				this.$emit('new_message_number', 0);
				top.postMessage({ st_popup_status: 0 }, document.referrer);
				// this.show_launcher = 0;
				this.$store.commit('set_show_launcher', 0);
			},
			reload_iframe: function () {
				var $self = this;
				/*socket.emit('LEAVE_CONVERSATION' ,{
				  page_id: livechat.getId(),
				  sender_id: $self.st_token,
				  name: window.user.name,
				  windowInfo:livechat.windowInfo,
				  survey_data: {
					name:window.user.name,
					phone:window.user.phone,
					email:window.user.email,
					address:window.user.address
				  },
				  properties:window.user.properties
				});*/

				axios.post('/app/v1/public/LEAVE_CONVERSATION', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					properties: window.user.properties
				}).then((response) => {
					if (response.data.status == 1) {
						var data = response.data.data;
						setTimeout(function () {
							if ($self.lsTest() === true) {
								localStorage.clear();
							}
							top.postMessage({ reload_iframe: true }, document.referrer);
							$self.$store.commit('set_token', '');
							// socket.emit('load1',null);
							$self.refresh_token();

							$self.minimize();
						}, 150);
					}
				}).catch(error => {
					console.log(error);
				});

				$self.reload_iframe_click=0
			},
			lsTest() {
				var test = 'test';
				try {
					localStorage.setItem(test, test);
					localStorage.removeItem(test);
					return true;
				} catch (e) {
					return false;
				}
			},
			uid() {
				return (performance.now().toString(36) + Math.random().toString(36)).replace(/\./g, "");
			},
			isMobile() {
				/* Storing user's device details in a variable*/
				let details = navigator.userAgent;

				/* Creating a regular expression 
				containing some mobile devices keywords 
				to search it in details string*/
				let regexp = /android|iphone|kindle|ipad/i;

				/* Using test() method to search regexp in details
				it returns boolean value*/
				let isMobileDevice = regexp.test(details);

				if (isMobileDevice) {
					return true;
				} else {
					return false;
				}
			},
			download_msg_txt: function () {
				var $self = this;
				var text = '';
				this.messages.forEach(function (message, index) {
					if (message.user_id != $self.st_token) {
						text += "USER: ";
					} else {
						text += "AGENT: ";
					}
					if (message.text != '') {
						text += message.text + "\n";
					}

				});
				var filename = 'chat_transcript';

				var element = document.createElement('a');
				element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
				element.setAttribute('download', filename);
				element.style.display = 'none';
				document.body.appendChild(element);
				element.click();
				document.body.removeChild(element);

			},
			refresh_token() {
				var $self = this;
				axios.get('/app/v1/public/load/').then((response) => {
					if (response.data.status == 1) {
						var st_token = response.data.st_token;
						livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token', st_token);
						$self.st_token = st_token;
					}
				}).catch(error => {
					console.log(error);
				});
			},
			playSound(sound) {
				if (sound) {
					var audio = new Audio(sound);
					audio.volume = 0.4;
					audio.play();
				}
			},
			toggle_widget_setting: function () {
				$('.widget-setting-dropdown').toggleClass('visible');
			},
			scrollToEnd: function () {
				var $self = this;
				setTimeout(function () {
					$self.insertDateLine();
				}, 150);
				setTimeout(function () {
					var $chat_content = $(document).find('.chat-content');
					var chatbox = $(document).find('.chatbox');
					chatbox.scrollTop($chat_content.height() + 99999);
				}, 250);
			},
			insertDateLine: function () {
				var $self = this;
				var date_array = [];
				$(document).find('.chatbox .chat-date-separator').remove();
				$(document).find('.chatbox .chat-message-main').each(function (index, value) {
					var timestamp = $(this).find('.chat-message-date').attr('data-time');
					var d = new Date(timestamp * 1000);
					var curr_date = d.getDate();
					var curr_month = d.getMonth() + 1;
					var curr_year = d.getFullYear();
					var date = curr_date + '/' + curr_month + '/' + curr_year;
					if ($.inArray(date, date_array) >= 0) {

					} else {
						date_array.push(date);
						date = $self.MDFormat(curr_year + '-' + curr_month + '-' + curr_date);
						if(date !='Hôm nay'){
							$('<div class="chat-date-separator"><span>' + date + '</span></div>').insertBefore($(this));
						}
					}
				});
			},
			MDFormat: function (MMDD) {
				var $self = this;
				MMDD = new Date(MMDD.replace(/-/g, "/"));
				var vn_mths = ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"];
				var en_mths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
				var mths = '';
				if ($self.$i18n.locale == 'vi') mths = vn_mths;
				else mths = en_mths;
				var strDate = "";

				var tday = new Date();
				tday.setHours(0, 0, 0, 0);

				var yterday = new Date();
				yterday.setHours(0, 0, 0, 0);
				yterday.setDate(yterday.getDate() - 1);

				var tmrw = new Date();
				tmrw.setHours(0, 0, 0, 0);
				tmrw.setDate(tmrw.getDate() + 1);

				if (tday.getTime() == MMDD.getTime()) {
					strDate = /*'Hôm nay';*/$self.$t('today');
				} else if (yterday.getTime() == MMDD.getTime()) {
					strDate = $self.$t('yesterday');//"Hôm qua";
				} else if (tmrw.getTime() == MMDD.getTime()) {
					strDate = $self.$t('tomorrow');
				} else {
					strDate = MMDD.getDate() + " " + mths[MMDD.getMonth()] + " " + MMDD.getFullYear();
				}

				return strDate;
			},
			showNotification: function (title, text, icon = this.page.button) {
				var hasFocus = this.hasFocus;
				if (window.Notification && !hasFocus) {
					if (Notification.permission === "granted") {
						text = text.replace('<br>', '');
						text = text.substring(0, 20);
						var n = new Notification(title, { body: text, icon: icon });
						setTimeout(n.close.bind(n), 5000);
						// };
					} else {
						console.log('Your browser doesn\'t support notifications.');
					}
				}
			},
			setLang: function (event) {
				var $self = this;
				var val = event.target.value;
				this.setting_language = val;
				window.livechat.setSettingLanguage(val);
				this.$store.commit('set_lang', val);
				$self.$i18n.locale = val;

				//send event
				axios.post('/app/v1/public/CHANGE_LANGUAGE', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					language: val,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
				}).then((response) => {
				}).catch(error => {
					console.log(error);
				});
			},
			setLangNotificationEvent: function (val) {
				window.livechat.setSettingLanguage(val);
				this.$store.commit('set_lang', val);
				$self.$i18n.locale = val;

				//send event
				axios.post('/app/v1/public/CHANGE_LANGUAGE', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					language: val,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
				}).then((response) => {
				}).catch(error => {
					console.log(error);
				});
			},
			detectURL: function (message) {
				if (!message) return;

				var newMessage = this.restoreHtmlTag(message);

				if (newMessage.startsWith("<a") && newMessage.endsWith("</a>")) return newMessage;

				var exp = /(\b(https?|ftps?|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
				if(exp.test(message)){
					var finalText = message.replace(exp, "<a href='$1' target='_blank'>$1</a>");
				}
				else{
					var urlPattern = /\b(?:https?|ftps?):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
					var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
					var emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
					var phoneNumberPattern = /^[+ -](\+?1\s*[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4} /gim;
					var finalText = message
						.replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
						.replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
						.replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>')
						.replace(phoneNumberPattern, '<a href="javascript:void(0)" class="click-phone" data-phone="$&">$&</a>');
				}
				return this.restoreHtmlTag(finalText);
			},
			escapeHtml: function (text) {
				return text
					.replace(/&/g, "&amp;")
					.replace(/</g, "&lt;")
					.replace(/>/g, "&gt;")
					.replace(/"/g, "&quot;")
					.replace(/'/g, "&#039;");
			},
			restoreHtmlTag: function (text) {
				return text
					.replace(/&amp;/g, "&")
					.replace(/&lt;/g, "<")
					.replace(/&gt;/g, ">")
					.replace(/&quot;/g, '"')
					.replace(/&#039;/g, "'");
			},
			changePrev: function (index_message) {
				var el = $('#slides__' + index_message);
				var countElement = el.attr('data-elements');
				var slideElement = el.parent();

				if (!this.slideIndexes[index_message]) var currentSlide = 0;
				else var currentSlide = this.slideIndexes[index_message];

				if (currentSlide == 0) {
					currentSlide = countElement - 1;
					var prevSlide = currentSlide - 1;
					var nextSlide = 0;
				}
				else {
					currentSlide = currentSlide - 1;
					if (currentSlide != 0) var prevSlide = currentSlide - 1;
					else var prevSlide = countElement - 1;
					var nextSlide = currentSlide + 1;
				}

				var offsetLeft = $('#slide__' + index_message + '_' + currentSlide).width();
				$('.slide__dot').removeClass('slick-active');
				$('.slick-dots li.slide__' + index_message + '_' + currentSlide).addClass('slick-active');
				// class="slide__dot" :class="(index==0)?'slick-active slide__' + index_message + '_' + index:'slide__' + index_message + '_' + index"   
				el.scrollLeft(currentSlide * offsetLeft);

				this.slideIndexes[index_message] = currentSlide;
				var newHrefPrev = '#slide__' + index_message + '_' + prevSlide;
				var newHrefNext = '#slide__' + index_message + '_' + nextSlide;

				setTimeout(function () {
					$('#slide__prev_' + index_message).attr('href', newHrefPrev);
					$('#slide__next_' + index_message).attr('href', newHrefNext);
				}, 500)
			},
			changeNext: function (index_message) {
				var el = $('#slides__' + index_message);
				var countElement = el.attr('data-elements');
				if (!this.slideIndexes[index_message]) var currentSlide = 0;
				else var currentSlide = this.slideIndexes[index_message];
				if (currentSlide == countElement - 1) {
					currentSlide = 0;
					var prevSlide = countElement - 1;
					var nextSlide = currentSlide + 1;
				}
				else {
					currentSlide = currentSlide + 1;
					if (currentSlide == countElement - 1) var nextSlide = 0;
					else var nextSlide = currentSlide + 1;
					var prevSlide = currentSlide - 1;
				}

				var offsetLeft = $('#slide__' + index_message + '_' + currentSlide).width();
				$('.slide__dot').removeClass('slick-active');
				$('.slick-dots li.slide__' + index_message + '_' + currentSlide).addClass('slick-active');
				el.scrollLeft(currentSlide * offsetLeft);

				this.slideIndexes[index_message] = currentSlide;
				var newHrefPrev = '#slide__' + index_message + '_' + prevSlide;
				var newHrefNext = '#slide__' + index_message + '_' + nextSlide;
				setTimeout(function () {
					$('#slide__prev_' + index_message).attr('href', newHrefPrev);
					$('#slide__next_' + index_message).attr('href', newHrefNext);
				}, 500)
			},

			openFormRating: function (message) {
				this.$store.commit('show_rating', true);
				this.customerFeedbackConfig = message.attachments.payload.feedback_screens[0].questions[0];
				this.customerFeedbackConfig.message_id = message.id
				this.customerFeedbackConfig.language = message.language != undefined ? message.language : 'en';
			},
			closeFormRating: function (dataEmit) {
				if (dataEmit.message_id != undefined) {
					var indexMes = this.messages.findIndex(mes => mes.id == dataEmit.message_id);
					if (indexMes != -1) {
						var mes = this.messages[indexMes];
						mes.is_rated = 1;
						mes.rating_star = dataEmit.rating_star;
						mes.rating_recommend = dataEmit.rating_recommend;
						this.messages.splice(indexMes, 1, mes);
					}
				}
				this.$store.commit('show_rating', false);
			},
			isHiddenName: function (keyMessage) {
				if (keyMessage == 0) return false;
				return this.messages[keyMessage].user_id == this.messages[keyMessage - 1].user_id &&
					this.messages[keyMessage].name == this.messages[keyMessage - 1].name
			},
			isHiddenTime: function (keyMessage) {
				if (this.messages[keyMessage + 1] == undefined) return false;
				return this.messages[keyMessage].user_id == this.messages[keyMessage + 1].user_id &&
					this.messages[keyMessage].name == this.messages[keyMessage + 1].name
			},
			closeModal: function () {
				$('#modalStatus').css('opacity', 0);
				$('#modalStatus').css('zIndex', -1);
			},
			closePhoneModal: function () {
				$('#modal-phonenumber').css('opacity', 0);
				$('#modal-phonenumber').css('zIndex', -1);
			},
			async copyPhoneNumber() {
				var _vmChat = this;
				try {
					const clipboardData =
						event.clipboardData ||
						window.clipboardData ||
						event.originalEvent?.clipboardData ||
						navigator.clipboard;

					clipboardData.writeText(_vmChat.phoneNumber);
					$('#modal-phonenumber').css('opacity', 0);
					$('#modal-phonenumber').css('zIndex', -1);
				} catch ($e) {
					console.log($e);
				}
			},
			getwindowInfo(filename) {
				let _vm = this;
				let windowInfo = localStorage.getItem("windowInfo");
				windowInfo = JSON.parse(windowInfo);
				if(typeof windowInfo =='object' &&  windowInfo != null){
					// console.log(windowInfo)
					// console.log( typeof windowInfo)
					if (Object.keys(windowInfo).length > 0) {
						let path = window.location.pathname;

						var index = windowInfo.findIndex(url => url.session_url == path);
						if (index != -1) {
							windowInfo = windowInfo[index];
						}
					} else {
						return false
					}
				}else{
					return false
				}
				
				// console.log('hieu');
				// console.log(windowInfo);
				// console.log(typeof windowInfo);
				let callWebhook = 0;
				if ((windowInfo.session_url != _vm.session_url || windowInfo.session_starttime != _vm.session_starttime)) {
					callWebhook = 1;
					_vm.session_url = windowInfo.session_url;
					_vm.session_starttime = windowInfo.session_starttime;
				} else if (windowInfo.interaction != undefined) {
					if (windowInfo.interaction.interaction_click != _vm.interaction_click || windowInfo.interaction.interaction_view != _vm.interaction_view || windowInfo.interaction.exact_interaction_click != _vm.exact_interaction_click) {
						callWebhook = 1;
						_vm.interaction_click = windowInfo.interaction.interaction_click;
						_vm.interaction_view = windowInfo.interaction.interaction_view;
						_vm.exact_interaction_click = windowInfo.interaction.exact_interaction_click;

					} else if (windowInfo.interaction.form_interaction_submit != _vm.form_interaction_submit && windowInfo.interaction.interaction_scroll != _vm.interaction_scroll) {
						callWebhook = 1;
						_vm.form_interaction_submit = windowInfo.interaction.form_interaction_submit;
						_vm.interaction_scroll = windowInfo.interaction.interaction_scroll;
					}
				}

				if (callWebhook == 1 && _vm.$store.state.st_token != undefined) {

					axios.post('/app/v1/public/windowInfo', {
						windowInfo: windowInfo,
						page_id: livechat.getId(),
						sender_id: _vm.st_token,
						name: window.user.name,
						survey_data: {
							name: window.user.name,
							phone: window.user.phone,
							email: window.user.email,
							address: window.user.address
						},
						properties: window.user.properties
					}).then((response) => {
					}).catch(error => {
						console.log(error);
					});
				}
			},
			reloaddata() {
				let _vm = this;
				let windowInfo = localStorage.getItem("windowInfo");
				if (_vm.reloadinterval === 0) {
					var windowInfoData = setInterval(_vm.getwindowInfo, 20000);
				}
				if (_vm.reloadinterval === 1) {
					clearInterval(windowInfoData);
				}
			},
			getSuggestions: function () {
				var $self = this;
				axios.post('/app/v1/public/TYPING', {
					page_id: livechat.getId(),
					text: $self.message_input,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					properties: window.user.properties
				}).then((response) => {
					if (response.data.suggestions != undefined && response.data.suggestions.length) {
						$self.suggest_data = response.data.suggestions
						$self.show_suggest = 1;
					}
					else $self.show_suggest = 0;
				}).catch(error => {
					console.log(error);
				});
			},
			sendSuggestion: function (suggestion) {
				var msg_id = this.uid();
				if (suggestion.type == 'postback') {
					this.clickMenu(suggestion.payload, suggestion.text);
				}
				else {
					this.sendMessage(suggestion.text, msg_id);
				}
				this.message_input = '';
				this.show_suggest = 0;
			},
			get_messages() {
				var $self = this;
				axios.get('/app/v1/public/v2/get_messages', {
					params: {
						st_token: $self.st_token,
						livechat_id: livechat.getId(),
					}
				}).then((response) => {
					if (response.data.status == 1) {
						var data = response.data.data;
						$self.messages = data;
						$self.current_time_m = response.data.last_mes_time;
						$self.poll();
						$self.polln();

						setTimeout(function () {
							$self.insertDateLine();
						}, 150);
						$self.scrollToEnd();
					} else {
					// $self.$store.commit('set_first_component', 'survey');
					}


				}).catch(error => {
					console.log(error);
				});
			}
		},
		beforeDestroy() {
			this.reloadinterval = 1;
			clearInterval(windowInfoData);
		},
		async mounted() {
			$(document).ready(function() {
				$('textarea#flex_item_right').keypress(function(event) {
					if (event.keyCode == 13) {
						if (event.shiftKey) {}
						else
						{
							event.preventDefault();
						}
					}
				});
			});
			if(this.page.show_microphone != undefined){
				this.show_microphone=this.page.show_microphone;
			}
			// var  windowInfoData  = setInterval(_vm.getwindowInfo, 20000);
			if (this.reloadinterval === 0) {
				this.reloaddata();
			}
			// document.getElementsByTagName('head')[0].appendChild( '.chat-content-w .chat-message .reply.active, .chat-content-w .chat-message .reply:hover{ background-color: '+page.color+'}');
			// Get the current page URL

			this.agent = {
				name: this.page.page_info.name,
				avatar: this.page.logo,
			};

			if (!this.isMobile()) {
				if (this.page.parent_user == 'C1184') {
					window.livechat.setSettingNoti(true);
					this.setting_noti = true;
				} else if (Notification.permission === "granted") {
					window.livechat.setSettingNoti(true);
					this.setting_noti = true;
				} else {
					window.livechat.setSettingNoti(false);
				}
			} else {
				window.livechat.setSettingNoti(true);
			}

			// console.log(ENV);
			var $self = this;
			

			if ($self.st_token) {
				setTimeout(function () {
					$self.get_messages();
				},50);
			} else { //neu ko ton tai token truoc do, thi cung ko co chatmessage, nen co the goi ham add 
				// $self.$store.commit('set_show_launcher', 1);
			}
			

			$('.chatbox').on('click', '.click-phone', function () {
				var phoneNumber = $(this).attr('data-phone');
				if (phoneNumber) {
					$self.phoneNumber = phoneNumber;
					$('#modal-phonenumber').css('opacity', 1);
					$('#modal-phonenumber').css('zIndex', 999999999);
				}
			})
			localStorage.getItem("lastname");
			$('.microphone').on('click', function () {
				$(this).toggleClass('open')
			})
			
			// this.getSuggestions();
		},
		watch: {
			
			/*message_input: function (val) {
				this.mixin_autoResize_resize(this.$refs.input_chat)
			},*/
			show_launcher: function (val) {
				var $self = this;
				if (val == 1) {
					setTimeout(function () {
						$self.scrollToEnd();
						$self.insertDateLine();
					}, 150);
				}
			},
			setting_sound: function (val) {
				window.livechat.setSettingSound(val);
			},
			hasFocus: function (val) {
			},
			/*lang: function(val){
			  // this.setting_language = val;
			  window.livechat.setSettingLanguage(val);
			  this.$store.commit('set_lang', val);
			},*/
			/*setting_noti: function(val){
			  window.livechat.setSettingNoti(val);
			},*/

			show_rating: function (val) {
				var $self = this;
				setTimeout(function () {
					$self.insertDateLine();
				}, 150);
				$self.scrollToEnd();
			},

			/*setting_language: function(val){
			  this.$emit('swithLang', this.setting_language);
			  // var Languages = window.livechat.getLanguages();
			},*/
			agent_id: function (val) {
				var $self = this;
				if (val != '') {
					// socket.emit('get_agent', {st_token:$self.st_token, agent_id: val});
				}
			},
		},

	}

</script>
<style scoped lang="css">
		    
	.icon-sendfile, .sendchat_box{margin: 0;}
	.flex_item.sendchat_box .sendchat_button:hover{background-color: transparent;}
	.flex_item.sendchat_box .sendchat_button svg,.icon-sendfile svg{fill:#0D182D !important}
	.flex_item.sendchat_box .sendchat_button:hover svg,.icon-sendfile svg:hover{fill:#0068ff !important}
	.chat-input textarea{    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Fira Sans, Droid Sans, Cantarell, Helvetica Neue, sans-serif !important;font-size: 1em;max-height: 300px; overflow: auto;}
	
	.tab-microphone{display: inline-table;list-style-type: none;width: 100%;margin: 5px 0;}
	.tab-microphone li{float: left;margin-right: 5px;}
	.tab-microphone li a{background-color: #e1e1e1;    padding: 2px 10px;  border-radius: 5px 5px 0 0;cursor: pointer;}
	.tab-microphone li.active a,.tab-microphone li:hover a{background-color: var(--color); color: #fff;}
	
	
	/* color button send */
	.coccoc-alo-ph-circle {
		width: 160px;
		height: 160px;
		top: 20px;
		left: 20px;
		position: absolute;
		background-color: transparent;
		-webkit-border-radius: 100%;
		-moz-border-radius: 100%;
		border-radius: 100%;
		border: 2px solid rgba(30, 30, 30, 0.4);
		opacity: .1;
		-webkit-animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		-moz-animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		-ms-animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		-o-animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		-webkit-transition: all .5s;
		-moz-transition: all .5s;
		-o-transition: all .5s;
		transition: all .5s;
	}

	.coccoc-alo-phone {
		background-color: transparent;
		width: 200px;
		height: 200px;
		cursor: pointer;
		margin: 0 auto;
		z-index: 200000 !important;
		-webkit-backface-visibility: hidden;
		-webkit-transform: translateZ(0);
		-webkit-transition: visibility .5s;
		-moz-transition: visibility .5s;
		-o-transition: visibility .5s;
		transition: visibility .5s;
		right: 150px;
		top: 30px;
	}

	.coccoc-alo-phone.coccoc-alo-green .coccoc-alo-ph-circle-fill {
		background-color: var(--color);
		opacity: .75 !important;
	}

	.coccoc-alo-ph-circle-fill {
		width: 100px;
		height: 100px;
		top: 50px;
		left: 50px;
		position: absolute;
		background-color: #000;
		-webkit-border-radius: 100%;
		-moz-border-radius: 100%;
		border-radius: 100%;
		border: 2px solid transparent;
		opacity: .1;
		-webkit-animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		-moz-animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		-ms-animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		-o-animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		-webkit-transition: all .5s;
		-moz-transition: all .5s;
		-o-transition: all .5s;
		transition: all .5s;
	}

	.coccoc-alo-ph-img-circle {
		width: 60px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		color: #fff;
		top: 70px;
		left: 70px;
		position: absolute;
		-webkit-border-radius: 100%;
		-moz-border-radius: 100%;
		border-radius: 100%;
		border: 2px solid transparent;
		opacity: .7;
		
	}

	.coccoc-alo-phone.coccoc-alo-green .coccoc-alo-ph-img-circle {
		background-color:var(--color);
	}

	.coccoc-alo-phone.coccoc-alo-green .coccoc-alo-ph-circle {
		border-color:var(--color);
		opacity: .5;
	}

	

	@-moz-keyframes coccoc-alo-circle-anim {
		0% {
			transform: rotate(0) scale(.5) skew(1deg);
			opacity: .1
		}
		30% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .5
		}
		100% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .1
		}
	}

	@-webkit-keyframes coccoc-alo-circle-anim {
		0% {
			transform: rotate(0) scale(.5) skew(1deg);
			opacity: .1
		}
		30% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .5
		}
		100% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .1
		}
	}

	@-o-keyframes coccoc-alo-circle-anim {
		0% {
			transform: rotate(0) scale(.5) skew(1deg);
			opacity: .1
		}
		30% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .5
		}
		100% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .1
		}
	}

	@keyframes coccoc-alo-circle-anim {
		0% {
			transform: rotate(0) scale(.5) skew(1deg);
			opacity: .1
		}
		30% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .5
		}
		100% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .1
		}
	}

	@-moz-keyframes coccoc-alo-circle-fill-anim {
		0% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
		50% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .2
		}
		100% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
	}

	@-webkit-keyframes coccoc-alo-circle-fill-anim {
		0% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
		50% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .2
		}
		100% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
	}

	@-o-keyframes coccoc-alo-circle-fill-anim {
		0% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
		50% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .2
		}
		100% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
	}

	@keyframes coccoc-alo-circle-fill-anim {
		0% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
		50% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .2
		}
		100% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
	}


	.voice-box{
		width: 60px;
		height: 60px;
		margin: 50px auto;
		border-radius: 50%;
		background-color: var(--color);
		display: table;
		vertical-align: middle;
		cursor: pointer;
	}
	.voice-box.voice-box-trash{
		background-color:#cdcdcd
	}
	.voice-box.voice-box-trash:hover{
		background-color:#9e9a9a
	}
	.voice-box i{
		display: table-cell;
    	vertical-align: middle;
		color: #fff;
    	font-size: 1.5em;
	}
	.voice-box.voice-box-trash i{
		color: #333;
	}
	.microphone-content .content{position: absolute;z-index: 99;width: 100%;text-align: center;top: 85%;}
	.menu_resolve{padding: 5px 11px !important;margin-top: -5px;border-radius: 4px;}
	.menu_resolve:hover{
		background-color: hsla(0, 0%, 100%, .3);
	}
	.microphone.open{color: var(--borderColor);}
	svg.light-start {
		fill: #FDBF00;
	}

	.sendchat_button {
		background-color: var(--borderColor);
		border: 1px solid var(--borderColor);
	}
	.loadding_input{
		color: var(--borderColor);
		position: absolute;
		z-index: 99;
		left: 35%;
		top: 35%;
	}
	.sendchat_button svg {
		fill: #fff !important;
	}

	.sendchat_button:hover {
		background-color: #fff;
		;
	}

	.sendchat_button:hover svg {
		fill: var(--borderColor) !important;
	}

	/* .chat-input textarea::-webkit-input-placeholder {
		font-style: italic;
	}

	.chat-input textarea::-moz-placeholder {
		font-style: italic;
	}

	.chat-input textarea::-moz-placeholder {
		font-style: italic;
	}

	.chat-input textarea::-ms-input-placeholder {
		font-style: italic;
	} */

	.chat-input textarea:focus::placeholder,
	.chat-input textarea.voice_open::-webkit-input-placeholder ,
	.chat-input textarea.voice_open::-moz-placeholder ,
	.chat-input textarea.voice_open::-ms-input-placeholder ,
	.chat-input textarea.voice_open::placeholder {
		color: transparent;
	}

	/*end color button send */
	.slick-dots li {
		position: relative;
		display: inline-block;
		width: 10px;
		height: 10px;
		margin: 0 3px;
		padding: 0;
		cursor: pointer;
	}

	.slick-dots li button {
		font-size: 0;
		line-height: 0;
		display: block;
		width: 10px;
		height: 10px;
		padding: 5px;
		cursor: pointer;
		color: transparent;
		border-radius: 50%;
		border: 0;
		outline: none;
		background: #D9D9D9;
	}

	.slick-dots li.slick-active button,
	.slick-dots li button:hover {
		background-color: var(--borderColor);
	}
	.h-header .widget-header-title{
		line-height: 34px;
		display: table-cell;
		vertical-align: middle;
	}
	.widget-header--top-wrapper{
		display: table;
		color: #fff;
		width: 100%;
	}
	.widget-header--top-wrapper .head-action>svg{
		margin-top: 7px !important;
		color: #cdcdcd;
		display: block !important;
		line-height: 25px;
		border: 1px solid #cdcdcd;
		width: 30px;
    	height: 22px;
		padding: 5px;
		fill: #cdcdcd;
		cursor: pointer;
	}
	.widget-header--top-wrapper .head-action>svg:hover,
	.widget-header--top-wrapper .head-action>svg:last-of-type:hover{
		fill:#333 ;
		border: 1px solid #333;
	}
	.widget-header--top-wrapper .head-action>svg:last-of-type{
		border-left: 0px solid transparent;
	}
	.h-header .h-header-top {
		display: table;
	}

	.h-header .h-header-top .h-header-top-out {
		display: table-cell;
		vertical-align: middle;
		padding-left: 5px;
	}
	.widget-setting-dropdown{
		top: 34px;
	}
	.h-header .h-header-top .h-header-top-out .head-action{
		position: absolute;
		z-index: 9;
		right: 0;
		top: 0px;
	}
	.slider .button {
		background: #e4e6eb;
		color: #fff;
		border: 0 none;
		border-radius: 20px;
		cursor: pointer;
		font-weight: bold;
		padding: 9px;
		text-transform: inherit;
		width: 80%;
		font-size: .9375rem;
		display: block;
		margin: 8px auto;
		opacity: .8;
	}

	/* css buttom rating */
	.slider .slide--feedback .button {
		border: 1px solid var(--borderColor);
		color: #ffff;
		background-color: var(--color);
	}

	.slider .slide--feedback .button:hover {
		color: var(--color);
		background-color: #ffff;
	}

	/* css buttom chat */
	.slider .button {
		border: 1px solid var(--borderColor);
		color: var(--color);
		background-color: #fff;
	}

	.slider .button:hover {
		background-color: var(--borderColor);
		color: var(--colorHover);
	}

	.chat-content-w .chat-message .reply {
		border-color: var(--borderColor);
		color: var(--color);
	}

	.chat-content-w .chat-message .reply:hover {
		background-color: var(--borderColor);
		color: var(--colorHover);
		border: 1px solid var(--borderColor);
	}

	.chat-content-w .chat-message .reply.active {
		background-color: var(--color);
		color: var(--colorHover);
	}

	.chat-content-w .chat-message .reply.active:hover {
		color: #ddd;
	}

	.h-header .logo {
		width: 60px;
		position: relative;
		margin: 0;
		
	}
	.h-header .logo img{
		border-radius: 50%;
		box-shadow: 0px 0px 4px #cdcdcd;
		width:100%
	}
	.h-header .h-header-top {
		width: calc(100% - 60px);
		position: relative;
		float: left;
		margin-left: 5px;
		margin-top: 5px;
	}

	.h-header .logo img {
		width: 60px !important;
		height: 60px !important;
	}

	#greenBar {
		position: initial;
	}

	#greenBar i {
		position: absolute;
		z-index: 99;
		right: 1px;
		top: 1px;
		font-size: 1.5em;
		color: #0ce6e7;
	}
	.file_pdf_progress .video-icon .title>div {
		position: relative;
	}
	.chat-content-w .chat-message.self .chat-message-content a.file_pdf{color:#337ab7}
	.chat-content-w .chat-message.self .chat-message-content a.file_pdf:hover{color:#1bbae1}
	

	.link-url-icon{display: table;}
	.link-url-icon .link_url{
		position: relative;
		background-color: #fff;
		width: 60px;
		display: table-cell;
    	vertical-align: middle;
		border-radius: 5px;
		text-align: center;
		font-size: 1.5em;
		color: #cdcdcd;
	}
	.link-url-icon .title{
		position: relative;
		float: left;
		text-align: left;
		padding: 0 0 0 5px;	
	}
	.video-icon img,
	.video-icon .img {
		position: relative;
		width: 42px;
		float: left;
	}

	.video-icon .img {
		display: table;
		text-align: center;
	}

	.video-icon .img span {
		display: table-cell;
		vertical-align: middle;
		text-transform: uppercase;
		text-align: center;
		color: #fff;
		font-weight: bold;
	}

	.video-icon .title {
		position: relative;
		width: calc(100% - 42px);
		float: left;
		text-align: left;
		padding: 0px 0 0 5px
	}

	.video-icon .title>div>span {
		font-size: .7rem;
		font-weight: 500;
		font-style: italic;
	}

	.chat-message.chat-message-main .chat-message-content-w {
		position: relative;
		word-wrap: break-word;
		/* overflow: hidden; */
	}

	.chat-message.chat-message-main .video_content,
	.chat-message.chat-message-main .file_pdf {
		float: left;
		background-color: #e5efff
	}

	.chat-message.chat-message-main .video_content video {
		border: 1px solid #f6f6f6;
		border-radius: 10px;
	}

	.chat-message.chat-message-main.self .video_content,
	.chat-message.chat-message-main.self .file_pdf {
		float: right;
		border-radius: 10px;
	}

	.chat-message.chat-message-main.self .file_pdf h5 {
		max-height: 32px;
		overflow: hidden;
	}


	.suggestions.PredictiveSuggestions__list__container {
		/*padding: 6px ​10px 0px 15px;*/
		/*padding: 10px;*/
		padding-top: 6px;
		padding-right: 10px;
		padding-bottom: 00px;
		padding-left: 15px;
		border-top: 1px solid rgb(232, 232, 235);
		/*transition: border-color 200ms ease-in 0s;*/
		position: relative;
	}

	.PredictiveSuggestions__suggestions-heading {
		text-align: left;
		display: inline-block;
		font-size: 13px;
		font-weight: 600;
		background: transparent;
		border: none;
		cursor: pointer;
		color: #484848;
	}

	/*.PredictiveSuggestions__icon {
    display: inline-block;
    background: transparent;
    border: none;
    padding: 0px;
    margin: 0px;
}



.PredictiveSuggestions__icon svg {
    pointer-events: all;
    cursor: pointer;
    opacity: 1;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    outline: none;
}
*/
	/*.PredictiveSuggestions__list__chevron--show {
    transform: rotate(0deg);
    transition: transform 0.3s ease-out;
}*/
	.PredictiveSuggestions__list__items--animate-in {
		opacity: 1;
		transition-delay: 0.2s;
		transition-delay: 0.5s;
		transition: opacity 0.75s ease-out;
	}

	.PredictiveSuggestions--animating-list-up {
		opacity: 1;
		transition-duration: 0.2s;
		transition-delay: 0.1s;
		transition-timing-function: ease-out;
	}

	.PredictiveSuggestions__list--desktop {
		margin-bottom: 12px;
	}

	.PredictiveSuggestions__list {
		margin: 0;
		padding: 0;
		list-style-type: none;
	}

	.PredictiveSuggestions__item {
		overflow: hidden;
		display: block;
		position: relative;
		text-align: left;
		border: none;
		font-size: 14px;
		padding: 0px;
		background: transparent;
		margin-right: 16px;
		height: 0px;
		opacity: 0px;
		cursor: pointer;
		height: 30px;
		opacity: 1;
		animation: flickerAnimation 0.5s infinite;
		color: rgb(240, 14, 14);
		animation-play-state: paused;
	}

	.PredictiveSuggestions__item:not(:hover) {
		text-decoration: none;
	}

	.PredictiveSuggestions__item:hover {
		text-decoration: underline;
	}

	.PredictiveSuggestions--collapsed {
		max-height: 36px;
	}

	.PredictiveSuggestions--collapsed ul.PredictiveSuggestions__list {
		/*display: none;*/
	}

	.PredictiveSuggestions--collapsed .PredictiveSuggestions__icon {
		transform: rotate(-180deg);
		transition: transform 0.2s ease-out;
	}

	.chat-message-main span.message {
		white-space: pre-line;
	}

	.mini-menu {
		z-index: 999;
		position: absolute;
		bottom: 43px;
		background: #fff;
		right: 72px;
	}

	.mini-menu ul li {
		position: relative;
		display: block;
		padding: 0.75rem 0.5rem;
		margin-bottom: -1px;
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, .125);
	}

	.mini-menu ul li:first-child {
		border-top-left-radius: 0.25rem;
		border-top-right-radius: 0.25rem;
	}

	.chat-controls {
		position: relative;
	}

	.mini-menu ul li:last-child {
		margin-bottom: 0;
		border-bottom-right-radius: 0.25rem;
		border-bottom-left-radius: 0.25rem;
	}

	.mini-menu ul li a {
		color: #2165ff;
		font-weight: 500;
	}

	/*hieu update*/
	.slide__next,
	.slide__prev,
	.slider:after,
	.slider:before {
		position: absolute;
		top: 5px;
		left: 5px;
		width: 25px;
		height: 25px;
		border: solid #000;
		border-width: 0 5px 5px 0;
		padding: 3px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.template_list {
		margin: 5px;
	}

	.slider-container .wrap-arrow {
		position: absolute;
		top: 43%;
		z-index: 99999;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
		background-color: #fff;
		cursor: pointer;
		opacity: 0.5;
	}
	.slider-container .wrap-arrow:hover{opacity: 0.9;}
	.slider-container .wrap-arrow.wrap-arrow-prev {
		left: 0;
	}

	.slider-container .wrap-arrow.wrap-arrow-next {
		right: 0;
	}
	.template_list .wrap-arrow .inner-arrow {
		position: relative;
		display: block;
	}

	/*end hieu update */

	.slider-container {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
		padding: 0 ;
	}

	.slider {
		width: 100%;
		/* height: 302px; */
		text-align: center;
		border-radius: 20px;
		overflow: hidden;
		position: relative;
	}

	.slides {
		display: flex;
		overflow-x: scroll;
		position: relative;
		scroll-behavior: smooth;
		scroll-snap-type: x mandatory;
		/* overflow: hidden; */
		overflow-x: scroll;
	}

	/* .slide:nth-of-type(even) {
  background-color: rgb(250, 246, 212);
} */

	.slide {
		/*display: flex;*/
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		width: 75%;
		/* height: 400px; */
		scroll-snap-align: start;
		margin-right: 0;
		box-sizing: border-box;
		background: white;
		transform-origin: center center;
		transform: scale(1);
	}

	.slide.slide--feedback {
		height: 100%;
	}

	.slide__text {
		font-size: 40px;
		/*font-weight: bold;*/
		/* font-family: sans-serif; */
		height: 100%
	}

	.slide a {
		background: none;
		border: none;
	}

	a.slide__prev,
	.slider::before {
		transform: rotate(135deg);
		-webkit-transform: rotate(135deg);
		left: 30%;
	}

	a.slide__next,
	.slider::after {
		transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
		right: 35%;
	}

	.slider img {
		display: block;
		width: 100%;
		height: 179px;
		/*border-radius: 20px 20px 0 0;*/
		object-fit: cover;
	}

	.slider .detail {
		background: #fff;
		/*border-radius: 0px 0px 20px 20px;*/
		padding: 10px 15px;
		height: calc(100% - 179px);
		position: relative;
		margin-top: 2%;
		margin-bottom: 3%;
	}

	.slider .detail::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;

	}

	.slider .title {
		font-size: 1.0375rem;
		font-weight: bold;
		text-align: left;
		color: #050505;
		margin-bottom: 5px;
		text-align: center;
	}

	.slider .des {
		text-align: center;
		color: #65676B;
		font-size: .8125rem;
		line-height: 1.4em;
	}



	.slides>div {
		margin-right: 1px;
		/* scroll-snap-align: start;
  flex-shrink: 0;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s; */
	}

	/* .slide:not(.current_slide) {
  display: none;
}
.slide.current_slide{
  transition: 1s;
  left: 0;
} */

	.table-content-list {
		list-style: none;
	}

	.table-content-list li {
		padding: 5px
	}

	.table-content-list li {
		padding: 5px
	}

	.table-content-list li .item {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		margin-bottom: 10px;
	}

	.table-content-list li .item span:first-child {
		width: 116px;
		margin-right: 6px;
	}

	.table-content-list li .item span {
		display: block;
		font-size: 1rem;
		line-height: 18px;
		word-break: break-word;
	}

	.table-content-list li .item span {
		color: #394E60;
	}

	.table-content-list li .item span:nth-child(2) {
		display: inline-block;
	}

	.slide__text--ticket {
		margin: 10px;
	}

	.slider--ticket {
		text-align: unset;
	}

	.detail--ticket {
		background-color: unset !important;
	}

	.text-center {
		text-align: center;
	}

	h6 {
		font-size: 1rem;
		font-weight: 400;
	}

	.slide__text--ticket__title {
		font-weight: 700;
		font-size: 1rem;
		line-height: 24px;
		padding: 0;
		margin-bottom: 6px;
	}

	.slide__text--ticket__subtitle {
		display: block;
		font-size: 0.875rem;
		margin-bottom: 12px;
		line-height: 20px;
	}

	.slider--ticket .slide {
		border-radius: 8px;
		background-color: #f9f7f7;
		height: 450px;
	}

	.button-disabled {
		color: #a7b3bf
	}

	.rating {
		display: inline-block;
		flex-direction: column;
		align-items: center;
		color: #b7b7b7;
		border-radius: 8px;
	}

	.rating .list {
		padding: 0;
		margin: 0;
		width: unset;
	}

	.rating .list .star {
		display: inline-block;
		font-size: 20px;
		transition: all .2s ease-in-out;
		cursor: pointer;
	}

	.rating .list .star.active {
		color: #ffe100;
	}

	.rating .list .star:first-child {
		margin-left: 0;
	}

	.mt-1 {
		margin-top: 1rem;
	}

	.modal-wrapper {
		position: fixed;
		top: 20px;
		right: 39px;
		bottom: 18px;
		left: 0;

		background: rgba(0, 0, 0, 0.8);
		z-index: -1;
		opacity: 0;

		-webkit-transition: opacity 0.2s ease-in;
		-moz-transition: opacity 0.2s ease-in;
		transition: opacity 0.2s ease-in;

		pointer-events: auto;
		border-radius: 10px;
	}

	.modal-wrapper>div {
		width: 90%;
		height: 15%;
		position: absolute;

		top: 0;
		bottom: 0;
		left: 0;
		right: 0;

		margin: auto;

		vertical-align: middle;
		padding: 20px;
		border-radius: 6px;
		border: rgb(22, 136, 197) solid 1px;
		background: #fff;
		z-index: 1;
		text-align: center;
	}

	.close {
		background: rgb(22, 136, 197);
		color: #ffffff;
		line-height: 25px;
		position: absolute;
		right: -12px;
		text-align: center;
		top: -10px;
		width: 24px;
		text-decoration: none;
		font-weight: bold;
		-webkit-border-radius: 12px;
		-moz-border-radius: 12px;
		border-radius: 12px;
	}

	.close:hover {
		background: rgb(22, 136, 197);
	}

	#modal-phonenumber .modal {
		text-align: initial;
		padding: 0;
		height: 20%;
	}

	#modal-phonenumber .modal-header {
		text-align: initial;
		padding: 15px;
		border-bottom: solid 1px #1688c5;
	}

	#modal-phonenumber .modal-content {
		text-align: initial;
		padding: 15px;
	}

	#dropdown-shortcode {
		width: 100%;
		margin: 10px -10px 0;
		position: absolute;
	}

	.dropdown-menu {
		top: auto;
		bottom: 100%;
		margin-bottom: 1px;
	}

	.open>.dropdown-menu {
		display: block;
	}

	.dropdown-quickchat ul {
		max-height: 50vh;
		overflow: auto;
	}

	.dropdown-quickchat ul li.active {
		background-color: rgb(204, 215, 228);
	}

	.dropdown-quickchat ul li {
		cursor: pointer;
		padding: 10px;
		border-bottom: 1px solid rgb(204, 215, 228);
	}

	.list-suggestion-body {
		border-radius: 15px;
	}

	.list-suggestion {
		margin-left: 5px;
		background-color: #fff;
		border: 1px solid;
		border-radius: 15px
	}

	.suggestion-option:hover {
		background-color: var(--hover-color);
		color: #fff;
	}
	.chat-content-w .chat-message .quick-replies .reply{box-shadow: 0px 0px 5px #cdcdcd;border:1px solid var(--borderColor);border-radius: 15px;}
	.chat-content-w .chat-message .quick-replies .reply a{color: var(--borderColor);    margin-top: 2px;}
	.chat-content-w .chat-message .quick-replies .reply:hover{background-color:var(--borderColor);}
	.chat-content-w .chat-message .quick-replies .reply:hover a{color:#fff}
	/* css P0008_prod */
	.P0008_prod .chat-content-w .chat-message .user-name.text{display: none;}
	.P0008_prod .chat-content-w .chat-message.text:not(.self){display: block;overflow: hidden;}
	.P0008_prod .chat-content-w .chat-message.text:not(.self) .message-sender{display: inline-table;width: 35px;position: relative;float: left;}
	.P0008_prod .chat-content-w .chat-message.text:not(.self) .chat-message-content-w{display: inline-table;width: calc(100% - 39px);position: relative;float: left;margin-left: 4px;}
	.P0008_prod .chat-content-w .chat-message .message-sender.message-sender-attachments{    /*visibility: hidden;*/ display: none;}
	
	.P0008_prod .chat-content-w .chat-message{font-size: 0.9rem;    padding: 0 16px 5px;}
	.P0008_prod .chat-content-w .chat-message .quick-replies .reply{border:1px solid #FFC912;background-color: #FFC912;    margin-top: 2px;    margin-bottom: 10px;}
	.P0008_prod .chat-content-w .chat-message .quick-replies .reply a{color:#0D182D;}
	/* 0072bc */
	.P0008_prod .chat-content-w .chat-message .reply.active, .P0008_prod .chat-content-w .chat-message .reply:hover{background-color:#fff;}
	.P0008_prod .chat-content-w .chat-message .reply.active a, .P0008_prod .chat-content-w .chat-message .quick-replies .reply:hover a{color:#3D4657}
	.P0008_prod .widget-header-title span{display: block;font-size: 0.9rem;color: #0D182D;font-weight: 500;}
	.P0008_prod .chat-content-w .chat-message .chat-message-avatar{    width: 32px; height: 32px;border: 2px solid; border-image-source: linear-gradient(180deg, #FFFFFF 0%, #FFF7DD 51.04%, #FFFBF0 100%);box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);}
	.P0008_prod .chat-content-w .chat-message .chat-message-content .message{background-color: #F3F3F5!important;color: #0D182D !important;border-radius: 4px 16px 16px 16px;padding:12px;margin:0 !important}
	.P0008_prod .chat-content-w .chat-message.self .chat-message-content .message{background-color: #ebf5ff!important;padding:5px 12px;box-shadow: none;border-radius: 16px 16px 4px 16px  !important;}
	.P0008_prod .slider .title{font-weight: 600;color:#0D182D !important;font-size: 0.9rem;}
	.P0008_prod .slider .des{color:#868C96;font-size: 0.8rem;    text-align: center;    text-align-last: center;}
	.P0008_prod .slider .button{background-color: #F3F3F5 !important;color:#3D4657;width: 100%;}
	.P0008_prod .slides::-webkit-scrollbar { display: none; }
	.P0008_prod .chat-content-w .chat-message .quick-replies{ display: -webkit-box;    flex-wrap: nowrap; -webkit-flex-wrap: nowrap;  -ms-flex-wrap: nowrap;overflow: scroll;margin: 0 -15px !important}
	/* .P0008_prod .chat-content-w .chat-message .quick-replies::-webkit-scrollbar { display: none; } */
	.P0008_prod .chat-content-w .chat-message.show_typing .chat-message-content .message{background-color: transparent!important;box-shadow: none !important;}
	.P0008_prod .chat-content-w .chat-message.show_typing .chat-message-content .message .loading-dots--dot{background-color: #0d182d!important;}
	.P0008_prod .chat-content-w .chat-message .quick-replies .reply{text-wrap: nowrap;     white-space: nowrap;   margin-left: 2px;box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);margin: 3px 3px 3px;    padding: 4px 12px;}
	.P0008_prod .slide__text{box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);margin: 0 5px;}
	.P0008_prod .slides>div:first-child{padding-left: 1px;}
	.P0008_prod .slides>div{padding-left: 1px;}
	.P0008_prod .slide:last-child{margin-right: 1px;}
	.P0008_prod  .slides>div{    margin: 10px 0;}
	.P0008_prod .slider img{height: 150px;}
	.P0008_prod .slider .detail{box-shadow: none;}
	.P0008_prod .logo{margin-bottom: 14px;}
	.P0008_prod .logo img{width: 48px;height: 48px;box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);border-radius: 50%;}
	.P0008_prod  .chat-content-w .chat-message .chat-message-content .message a{color:#0072BC}
	.P0008_prod  .loading-dots{    margin-left: 15px;opacity: 0.4;}
	.P0008_prod  .chat-message.chat-message-main .chat-message-content-w .chat-message-content .template_list{margin: 0 -10px;}
	.P0008_prod  .chat-controls{    padding:16px 7px !important;}
	/* end css P0008_prod */
</style>